export default {
  "custom": {
    linkedReference: 'Tham chiếu liên kết',
    boot: 'Bật',
    shutDown: 'Tắt',
    notLinked: 'Không liên kết',
    maxLinkedTip: 'Tối đa 2 liên kết {type} được phép, tự động khôi phục về Không liên kết',

    bar_Power: 'Nguồn điện',
    bar_Video: 'Chuyển đổi video',
    bar_Vol: 'Âm lượng',
    bar_Audio: 'Âm thanh',
    bar_Serial: 'Nối tiếp',
    bar_Air: 'Máy điều hòa',
    bar_Projection: 'Màn chiếu',
    bar_Remote: 'Điều khiển từ xa',
    bar_Matrix: 'IQShare Matrix',
    youMustSelectAllThreeImagesAtTheSameTime: 'Bạn phải chọn cả ba hình ảnh cùng một lúc',
    notSelected: 'Chưa chọn',
    choose: 'Chọn',
    disable: 'Vô hiệu hóa',
    "longPressAndDrag": "Nhấn giữ và kéo để điều chỉnh thứ tự danh sách",
    "isrestoreDefault": "Bạn có muốn khôi phục về trạng thái mặc định không?",
    "saveAndSync": "Lưu và đồng bộ",
    "restoreDefault": "Khôi phục mặc định",
    "limitPNG": "Chỉ có thể tải lên hình ảnh PNG!",
    "limit1M": "Kích thước hình ảnh không được vượt quá 1MB!",
    "selectTheImage": "Chọn hình ảnh",
    "textsuggestions": "Khuyến nghị: Biểu tượng PNG trắng 48*48 px, dưới 1MB",
    "iconLibrary": "Thư viện biểu tượng",
    "panelNavigationBarCustomization": "Thanh điều hướng bảng",
    "logoCustomization": "Logo bảng"
  },
  outlook: {
    privacy: 'Bind Microsoft Organization Privacy Agreement',
    privacyContent: "Agree to",
    AuthVerify4004One: 'Liên kết thất bại: Thuê bao Microsoft này (ID: ',
    AuthVerify4004Two: ') đã được tổ chức [',
    AuthVerify4004Three: '] sử dụng. Để liên kết lại, vui lòng hủy liên kết khỏi tổ chức gốc hoặc sử dụng thuê bao Microsoft khác.',
    theMicrosoftTenantIsOccupied: 'Thuê bao Microsoft đã được sử dụng',
    Viewtutorial: 'Xem hướng dẫn liên kết',
    checktenantID: 'Vui lòng kiểm tra xem Tenant ID, Application ID và Application Key của bạn có chính xác không',
    ErrorCode: 'Mã lỗi:',
    AuthorizationFailed: 'Ủy quyền thất bại',
    Accesshasbeengranted: 'Đã cấp quyền truy cập Microsoft Graph API',
    successfullyauthorizedDescribe: 'Các quyền cần thiết đã được ủy quyền thành công. Dữ liệu phòng họp sẽ được đồng bộ tự động. Vui lòng đóng trang này.',
    Close: 'Đóng',
    resourceID: 'ID tài nguyên',
    dialogTips: 'Mẹo',
    theAuthorizationIsDeleted: 'Đã hủy ủy quyền',
    theBindingIsSuccessful: 'Liên kết thành công',
    theUnbindingIsSuccessful: 'Hủy liên kết thành công',
    unbindingFailed: 'Hủy liên kết thất bại',
    theUnbindingHasBeenUnbound: 'Đã hủy liên kết',
    continueUnbinding: 'Đồng bộ Outlook sẽ dừng và tất cả sự kiện sắp tới sẽ bị xóa. Tiếp tục hủy liên kết?',
    areYouSureAboutUnbinding: 'Tất cả sự kiện Outlook sắp tới sẽ bị xóa và đồng bộ sẽ dừng. Hành động này không thể hoàn tác. Xác nhận hủy liên kết?',
    UnbindNotSynchronized: 'Sau khi liên kết, sự kiện Outlook mới cho phòng này sẽ được đồng bộ tự động (sự kiện cũ sẽ không được đồng bộ)',
    unbinding: 'Hủy liên kết',
    bindUnableToSelect: 'Đã liên kết, không thể chọn',
    permissAThird: 'Vui lòng ủy quyền để liên kết tài nguyên bên thứ ba',
    resourceMailbox: 'Email tài nguyên:',
    PleasecheckID: 'Ủy quyền thất bại! Vui lòng kiểm tra lại Tenant ID, Application ID và Client Secret của bạn.',
    Waitingforauthorization: 'Đang chờ ủy quyền...',
    Pleasecompletetheauthorization: 'Đã mở trang đăng nhập Microsoft 365. Vui lòng đăng nhập bằng tài khoản quản trị để hoàn tất ủy quyền.',
    pleaseEnterTheTenantID: 'Vui lòng nhập Tenant ID',
    pleaseEnterTheClientID: 'Vui lòng nhập Application ID',
    pleaseEnterTheClientSecret: 'Vui lòng nhập Client Secret',
    Authorizationcompleted: 'Ủy quyền hoàn tất',
    Authorizelogin: 'Ủy quyền đăng nhập Microsoft 365',
    ApplicationID: 'Tenant ID',
    ClientID: 'Application ID',
    ClientSecret: 'Client Secret',
    registTipOne: 'Vui lòng làm theo',
    registTipTwo: 'Hướng dẫn liên kết',
    registTipThree: 'Hoàn tất đăng ký ứng dụng Azure và cài đặt quyền trước khi điền vào các trường bên dưới.',
    MicrosoftDescribe: 'Bằng cách liên kết Microsoft 365, các cuộc họp được đặt trong Outlook/Teams có thể tự động đồng bộ với Q-NEX Console và Room Scheduler.',
    Addcalendarservice: 'Cài đặt đồng bộ lịch',
    Lasttimesynchronization: 'Thời gian đồng bộ cuối cùng',
    Allocated: 'Đã phân bổ',
    Total: 'Tổng cộng',
    Conferenceroomresources: 'Tài nguyên phòng họp',
    Bindingtime: 'Thời gian liên kết',
    Bindtheplatform: 'Nền tảng liên kết',
    Synchronousstate: 'Trạng thái đồng bộ',
    Organizationname: 'Tên tổ chức',
    Bindthirdpartycalendar: 'Liên kết lịch bên thứ ba',
    TenantIDTip: 'Định danh duy nhất trong Azure AD',
    ApplicationIDTip: 'ID ứng dụng đã đăng ký trong Azure',
    ApplicationSecretTip: 'Client secret được tạo trong Azure để xác thực'
  },
  "meetingManager": {
    IdleDisplayTextTable: 'Văn bản hiển thị khi không hoạt động',
    IdleDisplayText: 'Văn bản hiển thị khi không hoạt động:',
    IdleDisplayTextContent: 'Văn bản hiển thị khi phòng trống (mặc định: “Trống”)',

    duplicateMeetingRoomName: 'Tên phòng họp bị trùng',
    duplicateMeetingRoomNameContent: 'Đã tồn tại phòng họp có tên "{duplicate_content}". Vui lòng nhập tên khác.',
    NumberOfRoomPanels: 'Số lượng bảng điều khiển phòng',
    "Thecurrentterminalhasbeenboundtoanotherorganization": " Thiết bị đầu cuối hiện tại đã được liên kết với một tổ chức khác.",
    "theTerminalNameOrIDIsDuplicated": "Tên hoặc ID của bảng giống nhau",
    theRoomNameOrIDIsDuplicated: 'Tên phòng họp hoặc địa điểm đã tồn tại.',
    "AddMeetingRoom": "Thêm phòng họp",
    "EditMeetingRoom": "Chỉnh sửa phòng họp",
    "MeetingRoomName": "Tên phòng họp:",
    "Location": "Vị trí:",
    "ReservationApproval": "Phê duyệt đặt phòng:",
    "ApprovalListYes": "có",
    "ApprovalListNo": "không",
    "Capacity": "Sức chứa:",
    "RoomStatus": "Tình trạng phòng:",
    "BindRoomDisplay": "Kết nối bảng phòng:",
    "meeting_btnAdd": "Thêm",
    "meeting_btnEdit": "Chỉnh sửa",
    "meeting_btnBind": "Kết nối thiết bị",
    "meeting_btnDel": "Xóa",
    "meeting_tableRoomName": "Tên phòng họp",
    "meeting_tableRoomPlace": "Vị trí",
    "meeting_tableAppointmentApproval": "Phê duyệt đặt phòng",
    "meeting_tableCapacityForPeople": "Sức chứa",
    "meeting_tableMeetingRoomStatus": "Tình trạng phòng",
    "meeting_tableAvaliable": "Có sẵn",
    "meeting_tableOutofService": "Ngoài dịch vụ",
    "meeting_tableDoorBind": "Kết nối cửa",
    "meeting_tableBindNPS": "Kết nối NPS",
    "meeting_tableActions": "Hành động",
    "door_theNameOfTheTerminal": "Tên bảng:",
    "door_deviceID": "ID bảng:",
    "door_Wallpaper": "Ảnh nền:",
    "door_Wallpaper_text": "Kích thước ảnh đề xuất: 1280x800, định dạng PNG",
    "door_bindAMeetingRoom": "Kết nối phòng họp:",
    "door_table_name": "Tên bảng",
    "door_table_deviceID": "ID bảng",
    "door_table_status": "Tình trạng",
    "door_table_ipAddress": "Địa chỉ IP",
    "door_table_bindAMeetingRoom": "Kết nối phòng họp",
    "door_btnAdd": "Thêm",
    "door_btnBatchAdd": "Thêm theo nhóm",
    "door_btnEdit": "Chỉnh sửa",
    "door_btnBatchEdit": "Chỉnh sửa theo nhóm"
  },
  "InputSourcesLinkage": {
    "configurationAddTitle": "Thêm cấu hình",
    "configurationEditTitle": "Chỉnh sửa cấu hình",
    "dialogConfigName": "Tên cấu hình",
    "selectNMPAndNDP": "Thiết bị mục tiêu",
    "powerControl": "Kiểm soát nguồn",
    "executeCommand": "Thực hiện",
    "tableConfigName": "Tên cấu hình",
    "selectConfig": "Vui lòng chọn cấu hình"
  },
  "NPS": {
    "Relay": "Rơ le",
    "RelaySettings": "Cài đặt rơ le",
    "DevicePower": "Điều khiển nguồn thiết bị",
    "DeviceElevation": "Điều khiển nâng",
    "LinageWithNPSPower": "Liên kết với nguồn NPS",
    "PresentationSwitch": "Công tắc trình bày",
    "Duplicate": "Sao chép",
    "LinkagewithNPSPowe": "Liên kết với nguồn NPS"
  },
  "PTZ": {
    "powerSupplyON": "Bật",
    "powerSupplyOFF": "Tắt",
    "LEFT": "Trái",
    "RIGHT": "Phải",
    "UP": "Lên",
    "DOWN": "Xuống",
    "HOME": "Trang chủ",
    "ENLARGE": "Phóng to",
    "REDUCTION": "Thu nhỏ",
    "StopMovement": "Dừng di chuyển",
    "STOP": "Dừng zoom",
    "FOCUS": "Lấy nét",
    "SET_PRESETS0": "CÀI_ĐẶT_PRES0",
    "SET_PRESETS1": "CÀI_ĐẶT_PRES1",
    "SET_PRESETS2": "CÀI_ĐẶT_PRES2",
    "SET_PRESETS3": "CÀI_ĐẶT_PRES3",
    "SET_PRESETS4": "CÀI_ĐẶT_PRES4",
    "SET_PRESETS5": "CÀI_ĐẶT_PRES5",
    "SET_PRESETS6": "CÀI_ĐẶT_PRES6",
    "SET_PRESETS7": "CÀI_ĐẶT_PRES7",
    "SET_PRESETS8": "CÀI_ĐẶT_PRES8",
    "SET_PRESETS9": "CÀI_ĐẶT_PRES9",
    "USE_PRESETS0": "SỬ_DỤNG_PRES0",
    "USE_PRESETS1": "SỬ_DỤNG_PRES1",
    "USE_PRESETS2": "SỬ_DỤNG_PRES2",
    "USE_PRESETS3": "SỬ_DỤNG_PRES3",
    "USE_PRESETS4": "SỬ_DỤNG_PRES4",
    "USE_PRESETS5": "SỬ_DỤNG_PRES5",
    "USE_PRESETS6": "SỬ_DỤNG_PRES6",
    "USE_PRESETS7": "SỬ_DỤNG_PRES7",
    "USE_PRESETS8": "SỬ_DỤNG_PRES8",
    "USE_PRESETS9": "SỬ_DỤNG_PRES9"
  },
  "schedule": {
    "startLinkPowerStart": "Bật (Rơ le CBXs)  ",
    "startLinkPowerStop": "Tắt (Rơ le CBXs)  ",
    "dehumidification": "Khô  ",
    "airSupply": "Quạt  ",
    "masterControl": "Chính:  ",
    "powerSupply": "Nguồn  ",
    "lockScreen": "Khóa  ",
    "RecordingControl": "Kiểm soát ghi âm  ",
    "RecordingControlSystem": "Hệ thống ghi hình bài giảng  ",
    "LiquidCrystal": "Màn hình tương tác phẳng  ",
    "projector": "Máy chiếu  ",
    "othertype": "Khác  ",
    "childLock": "Khóa trẻ em  ",
    "energySaving": "Tiết kiệm năng lượng  ",
    "signalSourceSwitching": "Nguồn vào  ",
    "other": "Các tính năng khác:  ",
    "otherFunction": "Chức năng  ",
    "send": "Gửi  ",
    "ON": "BẬT  ",
    "OFF": "TẮT  ",
    "btnAddSchedule": "Khôi phục  ",
    "EditSchedulelist": "Chỉnh sửa lịch trình  ",
    "AddSchedulelist": "Thêm lịch trình  ",
    "RestoreSchedulelist": "Khôi phục  ",
    "btn": "Hủy  ",
    "btnNewList": "Lịch trình mới  ",
    "ListName": "Tên  ",
    "Cannotquit": "Bắt buộc  ",
    "NOCannotquit": "KHÔNG  ",
    "ListValidityPeriod": "Thời gian hiệu lực  ",
    "ListDescription": "Mô tả  ",
    "currentSchedule": "Danh sách lịch trình  ",
    "historySchedule": "Danh sách lịch sử  ",
    "selectTime": "Thời gian  ",
    "taskType": "Loại công việc  ",
    "selectBroadcasting": "Phát sóng  ",
    "selectDeviveControl": "Điều khiển thiết bị  ",
    "newSchedule": "Công việc mới  ",
    "newChecklist": "Danh sách kiểm tra mới  ",
    "titleStatus": "Trạng thái  ",
    "titleType": "Loại  ",
    "titleStartTime": "Thời gian bắt đầu  ",
    "titleEndTime": "Thời gian kết thúc  ",
    "titleRepeat": "Lặp lại  ",
    "titleName": "Tên  ",
    "titleAction": "Hành động  ",
    "tableEnabled": "Đã bật  ",
    "tablePaused": "Tạm dừng  ",
    "tableEdit": "Chỉnh sửa  ",
    "tableDelete": "Xóa",
    "tableVolumeEdit": "Âm lượng phát sóng  ",
    "tableBroadcastTitle": "Tiêu đề  ",
    "tableBroadcastContent": "Nội dung  ",
    "tableBroadcastList": "Danh sách  ",
    "tableBroadcast": "Cưỡng bức  ",
    "btnRemoveCompletely": "Xóa hoàn toàn  ",
    "btnEnabled": "Bật  ",
    "btnPaused": "Tạm dừng  ",
    "btnDelete": "Xóa  ",
    "repeat0": "T2  ",
    "repeat1": "T3  ",
    "repeat2": "T4  ",
    "repeat3": "T5  ",
    "repeat4": "T6  ",
    "repeat5": "T7  ",
    "repeat6": "CN  ",
    "dialogTitleAdd": "Nhiệm vụ điều khiển thiết bị mới  ",
    "dialogTitleEdit": "Chỉnh sửa nhiệm vụ điều khiển thiết bị  ",
    "newBroadcastingSchedule": "Nhiệm vụ phát sóng mới  ",
    "editBroadcastingSchedule": "Chỉnh sửa nhiệm vụ phát sóng  ",
    "chooseDevice": "Chọn thiết bị  ",
    "timeSetting": "Cài đặt thời gian  ",
    "controlBroadcasting": "Tùy chọn phát sóng  ",
    "controlOption": "Tùy chọn điều khiển  ",
    "scheduleName": "Tên nhiệm vụ:  ",
    "destination": "Điểm đến  ",
    "timeTilte": "Thời gian  ",
    "repeatTitle": "Lặp lại  ",
    "dialogRepeat0": "T2  ",
    "dialogRepeat1": "T3  ",
    "dialogRepeat2": "T4  ",
    "dialogRepeat3": "T5  ",
    "dialogRepeat4": "T6  ",
    "dialogRepeat5": "T7  ",
    "dialogRepeat6": "CN  ",
    "dialogOnceType": "Một lần  ",
    "dialogRepeatType": "Lặp lại  ",
    "mainPower": "Nguồn chính  ",
    "powerControl": "Điều khiển nguồn  ",
    "tableDisplayInputSwitch": "Công tắc đầu vào hiển thị  ",
    "tableAirConditioning": "Điều hòa không khí  ",
    "tableProjectionScreen": "Màn chiếu  ",
    "tableElectronicLock": "Khóa điện  ",
    "interactiveFlatPanel": "Bảng điều khiển màn hình phẳng  ",
    "displayInputSwitch": "Công tắc đầu vào hiển thị  ",
    "speakerVolume": "Âm lượng loa  ",
    "MICVolume": "Âm lượng micrô  ",
    "ProjectionScreen": "Màn chiếu  ",
    "ElectronicLock": "Khóa điện  ",
    "AirConditioning": "Điều hòa không khí",
    "AirConditioningPower": "Công suất  ",
    "AirConditioningModel": "Mẫu  ",
    "AirConditioningTEMP": "TEMP  ",
    "AirConditioningFanSpeed": "Tốc độ quạt  ",
    "OPEN": "MỞ  ",
    "CLOSE": "ĐÓNG  ",
    "UP": "LÊN  ",
    "DOWN": "XUỐNG  ",
    "PowerOFF": "TẮT  ",
    "PowerON": "MỞ  ",
    "ModelAuto": "Tự động  ",
    "ModelCool": "Làm mát  ",
    "ModelHeat": "Sưởi ấm  ",
    "ModelAir": "Bên không khí  ",
    "TEMPLow": "Thấp  ",
    "TEMPMiddle": "Trung bình  ",
    "TEMPHigh": "Cao  ",
    "btnSave": "Lưu  ",
    "btnNext": "TIẾP THEO  ",
    "StartTime": "Thời gian bắt đầu  ",
    "StopTime": "Thời gian dừng  ",
    "Mandatory": "Bắt buộc  ",
    "Video": "Video & Âm thanh  ",
    "Notification": "Thông báo  ",
    "btnFile": "Chọn tệp phương tiện  ",
    "LastingTime": "Thời gian kéo dài  ",
    "textTitle": "Tiêu đề  ",
    "textContent": "Nội dung  ",
    "textTitleLetters": "Ít hơn 60 ký tự  ",
    "textContentLetters": "Ít hơn 320 ký tự  ",
    "CannotquitYES": "CÓ  ",
    "CannotquitNo": "Không  ",
    "YES": "CÓ  ",
    "No": "Không  ",
    "delTitleContent": "Bạn có chắc chắn muốn xóa bộ lập lịch này không?  ",
    "delTitleListContent": "Bộ lập lịch đã xóa sẽ được chuyển vào danh sách lịch sử và có thể khôi phục lại  ",
    "deleListTitle": "Xóa bộ lập lịch?  ",
    "delTitleListContent1": "Việc xóa bộ lập lịch sẽ xóa các nhiệm vụ liên quan, vui lòng xác nhận.  ",
    "deleListTitle1": "Bạn có chắc chắn muốn xóa bộ lập lịch này không?  ",
    "delTitle": "Xóa?  ",
    "btnConfirm": "Xác nhận  ",
    "coxAll": "TẤT CẢ  ",
    "coxBroadcasting": "Phát sóng  ",
    "coxDeviveControl": "Điều khiển thiết bị  ",
    "rdMandatory": "CÓ  ",
    "noRdMandatory": "KHÔNG  ",
    "startDate": "Ngày bắt đầu  ",
    "endedDate": "Ngày kết thúc  ",
    "or": "-  ",
    "broadcastingType": "Loại",
    "ChooseTime": "Chọn giờ  ",
    "ChooseDate": "Chọn ngày  ",
    "newScheduleList": "Lịch mới  ",
    "editScheduleList": "Chỉnh sửa lịch  ",
    "listName": "Tên  ",
    "listValidityPeriod": "Thời gian hiệu lực  ",
    "listDescription": "Mô tả  ",
    "cancel": "Hủy  ",
    "confirm": "Xác nhận  ",
    "save": "Lưu  ",
    "addSuccess": "Thêm thành công!  ",
    "addError": "Thêm thất bại!  ",
    "editSuccess": "Chỉnh sửa thành công!  ",
    "editError": "Chỉnh sửa thất bại!  ",
    "delSuccess": "Xóa thành công!  ",
    "delError": "Xóa thất bại!  ",
    "restoreSuccess": "Danh sách lịch đã được khôi phục thành công  ",
    "restoreError": "Khôi phục danh sách lịch thất bại  ",
    "restoreTitleContent": "Thời gian này xung đột với thời gian trong danh sách, vui lòng chọn lại  ",
    "Enabled": "Đã bật  ",
    "Paused": "Tạm dừng  ",
    "Title": "Tiêu đề:  ",
    "Content": "Nội dung:  ",
    "errorScheduleNameRequired": "Tên nhiệm vụ phải được điền  ",
    "errorDeviceRequired": "Vui lòng chọn thiết bị mục tiêu  ",
    "deleTitle": "Bạn có chắc chắn muốn xóa nhiệm vụ này không?  ",
    "loopList": "Danh sách lặp lại  ",
    "errorPleaseDateRange": "Vui lòng chọn phạm vi ngày  ",
    "addError_2009": "Tên lịch trùng lặp  ",
    "conflicts": "Thời gian nhiệm vụ xung đột với các nhiệm vụ sau:  ",
    "Pleaseagain": "Vui lòng nhập lại  ",
    "errorScheduleName": "Tên nhiệm vụ  ",
    "errorListName": "Tên lịch  ",
    "today": "Hôm nay  ",
    "yesterday": "Ngày hôm qua  ",
    "thisWeek": "Tuần này  ",
    "lastWeek": "Tuần trước  ",
    "lastMonth": "Tháng trước  ",
    "thisMonth": "Tháng này  ",
    "times": "Lần  ",
    "TimeConflicts": "Xung đột thời gian  ",
    "editError_2006": "Không tìm thấy thiết bị  ",
    "editError_2010": "Tên nhiệm vụ trùng lặp  ",
    "ListTimeExpired": "Thời gian của lịch đã hết hạn, vui lòng chọn lại  ",
    "TimeExpired": "Thời gian hết hạn  ",
    "ControlOption": "Thiếu tùy chọn điều khiển  ",
    "Pleaseleastone": "Vui lòng chọn ít nhất một tùy chọn điều khiển  ",
    "Enter": "Nhập  ",
    "TitleFilled": "Tiêu đề phải được điền  ",
    "ContentFilled": "Nội dung phải được điền  ",
    "PleaseMediaFile": "Vui lòng chọn một tệp phương tiện  ",
    "PleaseSchedule": "Vui lòng chọn một nhiệm vụ  ",
    "delTitleScheduleContent": "Nhiệm vụ đã xóa không thể khôi phục.  ",
    "deleTitleSchedule": "Bạn có chắc chắn muốn xóa nhiệm vụ này không?  ",
    "deleteScheduleTitle": "Vui lòng chọn nhiệm vụ để xóa  ",
    "PleaseFillColumn": "Vui lòng điền tên chương trình  ",
    "PleaseDate": "Vui lòng chọn ngày  ",
    "Previous": "Trước  ",
    "RemoteControl": "Điều khiển từ xa  ",
    "taskhasexpired": "Nhiệm vụ này đã hết hạn, vui lòng liên hệ với người tạo để cập nhật thời gian.  ",
    "execute": "Thực thi  ",
    "broadcastingList": "Danh sách phát sóng  ",
    "volumeSuccess": "Đã cài đặt âm lượng thành công  ",
    "volumeFailed": "Cài đặt âm lượng thất bại  "
  },
  "Automation": {
    "nameDuplicate": "Tên công việc trùng tự động  ",
    "Automation": "Tự động hóa  ",
    "if": "Nếu:  ",
    "ifContent": "Phần 'Nếu' cho phép bạn thiết lập các điều kiện dựa trên dữ liệu cảm biến. Chọn cảm biến và chỉ định các điều kiện như 'Nhiệt độ > 26°C'.  ",
    "then": "Sau đó:  ",
    "thenContent": "Phần 'Sau đó' cho phép bạn chọn thiết bị và xác định hành động cho chúng. Chọn các thiết bị như NMP1, NMP2 và chỉ định các hành động như 'Bật + Làm mát' cho điều hòa.  ",
    "btnDelete": "Xóa  ",
    "Add": "Thêm  ",
    "taskName": "Tên công việc  ",
    "dialogTaskName": "Tên công việc:  ",
    "Statue": "Trạng thái  ",
    "DevicesApplied": "Thiết bị áp dụng  ",
    "Operation": "Hoạt động  ",
    "AirConditioningPower": "Công suất  ",
    "AirConditioningModel": "Mẫu  ",
    "AirConditioningFanSpeed": "Tốc độ quạt  ",
    "bold": "Xoay  ",
    "selectTask": "Vui lòng chọn công việc  ",
    "autoTaskAdd": "Thêm công việc tự động  ",
    "autoTaskEdit": "Chỉnh sửa công việc tự động  ",
    "Destination": "Điểm đến  ",
    "selectConditions": "Vui lòng chỉ định hành động mà bạn muốn thực hiện.  ",
    "selectDestination": "Vui lòng chọn thiết bị NMP mục tiêu, sau đó chỉ định hành động bạn muốn thực hiện  ",
    "AirConditioningTEMP": "Nhiệt độ  ",
    "AirConditioningHumidness": "Độ ẩm  ",
    "noData": "Chưa có công việc nào được thêm. Nhấn nút \"Thêm\" để thêm công việc.  "
  },
  "rs232Translation": {
    "reliveBinding": "Hủy liên kết  ",
    "RELIVEBINDING": "Hủy liên kết",
    "ACTO": "ACTO",
    "AMENA": "AMENA",
    "APPOTRONICS": "APPOTRONICS",
    "APTI": "APTI",
    "ASEE": "ASEE",
    "ASK": "ASK",
    "AUCMA": "AUCMA",
    "AUX": "AUX",
    "BARCO": "BARCO",
    "BENQ": "BENQ",
    "BOERKA": "BOERKA",
    "BOXLIGHT": "BOXLIGHT",
    "Canon": "Canon",
    "CARRIER": "CARRIER",
    "CHANGHONG": "CHANGHONG",
    "CHIGO": "CHIGO",
    "CHRISTIE": "CHRISTIE",
    "Chunlan": "Chunlan",
    "COSTAR": "COSTAR",
    "CROWN": "CROWN",
    "CX": "CX",
    "DAEWOO": "DAEWOO",
    "DAIKIN": "DAIKIN",
    "DIGITEL": "DIGITEL",
    "DONGBAO": "DONGBAO",
    "EIKI": "EIKI",
    "electra": "electra",
    "Electrolux": "Electrolux",
    "EPSON": "EPSON",
    "FEILU": "FEILU",
    "FOUNDER": "FOUNDER",
    "Frestec": "Frestec",
    "Fujitsu": "Fujitsu",
    "Galanz": "Galanz",
    "GREE": "GREE",
    "Haier": "Haier",
    "Hisense": "Hisense",
    "HITACHI": "HITACHI",
    "HP": "HP",
    "HUIFENG": "HUIFENG",
    "InFocus": "InFocus",
    "IQ": "IQ",
    "JVC": "JVC",
    "KODAK": "KODAK",
    "LANGER": "LANGER",
    "LENOVO": "LENOVO",
    "LG": "LG",
    "LITTLESWAN": "LITTLESWAN",
    "LUMENS": "LUMENS",
    "McQuay": "McQuay",
    "Microtek": "Microtek",
    "Mitsubishi": "Mitsubishi",
    "NANFENG": "NANFENG",
    "NEC": "NEC",
    "OPTOMA": "OPTOMA",
    "PALOROID": "PALOROID",
    "panisonic": "panisonic",
    "PHILIP": "PHILIP",
    "PJD": "PJD",
    "PLUS": "PLUS",
    "POLAROID": "POLAROID",
    "PROPIX": "PROPIX",
    "PROXIMA": "PROXIMA",
    "RAYBO": "RAYBO",
    "ROWA": "ROWA",
    "Samsung": "Samsung",
    "SANYO": "SANYO",
    "SAST": "SAST",
    "SEEMILE": "SEEMILE",
    "SHARP": "SHARP",
    "shengfeng": "shengfeng",
    "Shinco": "Shinco",
    "shuanglu": "shuanglu",
    "Sony": "Sony",
    "SOVA": "SOVA"
  },
  "VcbEdit": {
    "VcbNameNoNull": "Tên CBX không thể để trống  ",
    "BrandNoNull": "Thương hiệu không thể để trống  ",
    "ModelNoNull": "Mẫu mã không thể để trống  ",
    "AcNoNull": "Điều khiển điều hòa không thể để trống  ",
    "RcNoNull": "Điều khiển từ xa không thể để trống"
  },
  "route": {
    customize: 'Tùy chỉnh',
    "InputSourcesLinkage": "Liên kết nguồn đầu vào  ",
    "Automation": "Tự động hóa  ",
    "dashboard": "Dashboard",
    "i18n": "I18n  ",
    "organizationMge": "Nhóm  ",
    "userMge": "Người dùng  ",
    "authorityMge": "Quyền  ",
    "roleMge": "Vai trò  ",
    "equipmentMge": "Thiết bị  ",
    "workstationMge": "Phương tiện",
    "cloudDiskMge": "Điều khiển lưu trữ  ",
    "operationLog": "Nhật ký hoạt động  ",
    "setting": "Cài đặt  ",
    "resourceMge": "Quản lý tài nguyên  ",
    "storageMge": "Quản lý lưu trữ  ",
    "interfaceRename": "Đổi tên giao diện  ",
    "processorManager": "Trình quản lý bộ xử lý  ",
    "projectorCode": "Quản lý mã serial  ",
    "projectorCodeSetting": "Cài đặt mã serial  ",
    "RepairLog": "Nhật ký sửa chữa  ",
    "remoteControl": "Mã điều khiển từ xa  ",
    "acCode": "Mã điều khiển điều hòa  ",
    "cardMge": "Thẻ  ",
    "cardLog": "Nhật ký sử dụng thẻ  ",
    "cardManager": "Quản lý thẻ  ",
    "meetingManager": "Cuộc họp  ",
    "meetingRoomManager": "Quản lý phòng  ",
    "meetingDoorManager": "Quản lý bảng"
  },
  "navbar": {
    "logOut": "Đăng xuất  ",
    "dashboard": "Bảng điều khiển  ",
    "screenfull": "Toàn màn hình  ",
    "language": "Ngôn ngữ  ",
    "userConsole": "Console Q-NEX  ",
    "BackTianwa": "Quay lại Tianwa"
  },
  "feedback": {
    "Feedback": "Phản hồi  ",
    "email": "Vui lòng để lại email của bạn để nhận phản hồi từ chúng tôi.  ",
    "content": "Chào mừng và để lại tin nhắn để cải thiện sản phẩm của chúng tôi. Cảm ơn bạn vì các nhận xét.  ",
    "submit": "Gửi  ",
    "emailNoEmpty": "Email không thể để trống  ",
    "emailTrueRule": "Vui lòng nhập đúng định dạng email  ",
    "contentNoEmpty": "Nội dung không thể để trống  ",
    "feedbackSuccess": "Phản hồi thành công  ",
    "feedbackFailed": "Phản hồi thất bại  ",
    "emailNoChinese": "Hộp thư không thể chứa ký tự Trung Quốc  ",
    "emailLength": "Từ 5 đến 100 ký tự  ",
    "GroupNameLength": "Từ 1 đến 20 ký tự  ",
    "emailSpecialString": "Hộp nhập này không thể chứa chuỗi đặc biệt"
  },
  "login": {
    "title": "CHÀO MỪNG  ",
    "logIn": "Đăng nhập  ",
    "username": "Tên người dùng  ",
    "password": "Mật khẩu  ",
    "any": "bất kỳ  ",
    "thirdparty": "Hoặc kết nối với  ",
    "thirdpartyTips": "Không thể mô phỏng trên máy tính cục bộ, vui lòng kết hợp mô phỏng kinh doanh của riêng bạn!!!  ",
    "placeholder": "[  \n  \"Tên người dùng\",  \n  \"Mật khẩu\",  \n  \"Mã xác nhận\"  \n]  ",
    "userNameTitle": "Tên người dùng sai!  ",
    "forget": "Quên rồi?  ",
    "loginTitle0": "Đăng nhập thành công!  ",
    "loginTitle1000": "Tên người dùng hoặc mật khẩu sai!  ",
    "loginTitle1001": "Tên người dùng và mật khẩu phải được điền đầy đủ!  ",
    "loginTitle1002": "Mã xác nhận phải được điền đầy đủ!  ",
    "loginTitle1003": "Trạng thái người dùng không hợp lệ, đăng nhập thất bại!  ",
    "loginTitle1004": "Lỗi mã xác nhận!  ",
    "loginTitle1005": "Chưa đăng nhập, vui lòng đăng nhập trước!  ",
    "loginTitleUserName": "Tên người dùng phải được điền đầy đủ!  ",
    "loginTitlePwd": "Mật khẩu phải được điền đầy đủ!  ",
    "loginTitleVercode": "Mã xác nhận phải được điền đầy đủ!  ",
    "errorLogin": "Quyền người dùng không đủ, không thể đăng nhập!  ",
    "titleLoginNameFormat": "Phải bao gồm ký tự hoặc ký tự và số."
  },
  "organizationMge": {
    "CanTDragTop": "Không thể chuyển đến gốc  ",
    "prefixCannotBeEmpty": "Tiền tố của tài khoản quản trị viên siêu không thể để trống  ",
    "enterEnglishLetters": "Tiền tố của tài khoản quản trị viên siêu chỉ có thể nhập chữ cái tiếng Anh và số  ",
    "dateNotSelected": "Ngày bắt đầu của thời gian hiệu lực dịch vụ phát trực tuyến chưa được chọn  ",
    "btnAddChild": "Thêm cấp dưới  ",
    "btnAddSibling": "Thêm anh/chị em  ",
    "title": "Lưu ý:  ",
    "againTitle": "Vui lòng xác nhận lại:  ",
    "sort": "Sắp xếp:  ",
    "realName": "Tên thật:  ",
    "titleShooleRq": "Trường này phải được điền  ",
    "titleShooleNub": "ít hơn 100 ký tự  ",
    "schoolName": "Tên nhóm:  ",
    "type": "Loại nhóm:  ",
    "accountPrefix": "Tài khoản quản trị viên:  ",
    "organization": "Nhà phân phối  ",
    "terminalMechanism": "Người dùng cuối  ",
    "equipmentNum": "Số thiết bị:  ",
    "organizationNum": "Số nhóm đầu cuối:  ",
    "adminName": "Tài khoản quản trị viên:  ",
    "adminPwd": "Mật khẩu quản trị viên:  ",
    "edit": "Chỉnh sửa  ",
    "add": "Thêm  ",
    "del": "Xóa  ",
    "addSuccess": "Thêm thành công  ",
    "addError": "Thêm thất bại!  ",
    "editSuccess": "Sửa đổi thành công  ",
    "editError": "Sửa đổi thất bại!  ",
    "delSuccess": "Xóa thành công!  ",
    "delWarn": "Không thể xóa nhóm này với các thiết bị đã gắn bó  ",
    "delError": "Xóa thất bại!  ",
    "cancel": "Hủy  ",
    "confirm": "Xác nhận  ",
    "save": "Lưu  ",
    "TrialWorkstation": "Hiện tại bạn đang trong trạng thái thử nghiệm chỉ có thể phát sóng và phát trực tiếp tối đa 3 thiết bị đầu cuối.  ",
    "Normal": "Bình thường  ",
    "NormalWorkstation": "Thời gian hiệu lực dịch vụ phát trực tuyến của bạn là từ  ",
    "to": "đến  ",
    "Advent": "Mùa Vọng  ",
    "AdventWorkstationOne": "Dịch vụ phát trực tuyến của bạn sẽ hết hạn vào ngày",
    "AdventWorkstationTwo": ", vui lòng liên hệ với đại lý của bạn để gia hạn kịp thời cho việc sử dụng bình thường.  ",
    "Expired": "Hết hạn  ",
    "ExpiredWorkstation": "Dịch vụ phát trực tuyến của bạn đã hết hạn, vui lòng liên hệ với đại lý của bạn để gia hạn kịp thời.  ",
    "admin": "Quản trị viên:  ",
    "serviceState": "Dịch vụ phương tiện phát trực tuyến:  ",
    "serviceStateLIST": "Dịch vụ phương tiện phát trực tuyến  ",
    "ValidityPeriod": "Thời gian hiệu lực:  ",
    "ValidityPeriodLIST": "Thời gian hiệu lực  ",
    "Trial": "Dùng thử  ",
    "Permanent": "Vĩnh viễn  ",
    "AnnualBilling": "Thanh toán hàng năm  ",
    "mediaValidityPeriod": "Thời gian hiệu lực:  ",
    "mediaValidityPeriodLIST": "Thời gian hiệu lực  ",
    "contactInformation": "Chi tiết liên lạc (để nhắc gia hạn dịch vụ phát trực tuyến)  ",
    "company": "Tên công ty:  ",
    "email": "Email:  ",
    "phone": "Điện thoại:  ",
    "StartDate": "Ngày bắt đầu  ",
    "EndDate": "Ngày kết thúc  ",
    "To": "Đến  ",
    "TerminalName": "Tên người dùng cuối  ",
    "Competence": "Quản trị viên  ",
    "operate": "Hoạt động  ",
    "statusFilter": "Bộ lọc trạng thái  ",
    "disableStreaming": "Bạn có chắc chắn muốn tắt dịch vụ phát trực tuyến không?  ",
    "enableStreaming": "Bạn có chắc chắn muốn bật dịch vụ phát trực tuyến không?  ",
    "disableStreamingContent": "Khi dịch vụ phát trực tuyến bị tắt, nhóm sẽ không thể sử dụng các chức năng liên quan đến phát sóng và phát trực tiếp.  ",
    "enableStreamingContent": "Vui lòng chỉnh sửa thời gian hiệu lực cho các nhóm có dịch vụ phát trực tuyến đã hết hạn.  ",
    "search": "Nhập tên tổ chức  ",
    "optionsYearZero": "Vui lòng chọn",
    "optionsYearOne": "Một năm  ",
    "optionsYearTwo": "Hai năm  ",
    "optionsYearThree": "Ba năm  ",
    "dialogName": "Tên:  ",
    "detTitle": "Xóa nhóm sẽ khiến tất cả nội dung bên dưới nó bị xóa theo.  ",
    "groupDelTitle": "Bạn có chắc chắn muốn xóa nhóm này không?  ",
    "delTitle": "Xóa?  ",
    "delTitleContent": "Nội dung đã chọn sẽ bị xóa khỏi cơ sở dữ liệu. Thao tác này không thể hoàn tác. Bạn có chắc chắn muốn tiếp tục không?  ",
    "delCancelButton": "Hủy  ",
    "delConfirmButton": "Xác nhận  ",
    "copySuccess": "Nội dung đã được sao chép vào bộ nhớ tạm.  ",
    "copyError": "Trình duyệt không hỗ trợ sao chép tự động  ",
    "error1200": "Tên nhóm trùng lặp  ",
    "error1201": "Trùng lặp nhóm hoặc ID nhóm  ",
    "error1202": "Vượt quá số lượng thiết bị có thể kết nối  ",
    "error1203": "Tên người dùng trùng lặp  ",
    "error1204": "Đã có một nhóm với tên giống nhau ở cùng một cấp độ  ",
    "error1210": "Vui lòng nhập mật khẩu quản trị viên  ",
    "warningGroup": "Chọn nhóm!  ",
    "warningTerminal": "Nhóm thiết bị đầu cuối không thể tạo nhóm con!  ",
    "account": "Tài khoản trùng lặp  ",
    "titleOrganization": "Lưu ý: Tiền tố tài khoản được thiết lập ở cấp tổ chức. Tất cả tài khoản người dùng trong tổ chức này sẽ dùng chung một tiền tố.",
    "all": "Tất cả"
  },
  "userMge": {
    "nickName": "Biệt danh  ",
    "contentWithBrand": "Nhập thương hiệu hoặc mẫu  ",
    "contentwithIp": "Tìm kiếm theo tên thiết bị hoặc địa chỉ IP.  ",
    "btnAdd": "Người dùng mới  ",
    "btnDelete": "Xóa  ",
    "btnDownload": "Tải mẫu xuống  ",
    "btnImport": "Nhập hàng loạt  ",
    "btnExport": "Tải xuống  ",
    "btnDisable": "Vô hiệu hóa  ",
    "btnEnable": "Kích hoạt  ",
    "accountType": "Lọc theo vai trò  ",
    "organizationName": "Lọc theo nhóm  ",
    "content": "Tìm kiếm  ",
    "systemAccount": "ID người dùng  ",
    "idCardNumber": "ID nhân viên  ",
    "customizeAccount": "Tài khoản tùy chỉnh  ",
    "userName": "Tên  ",
    "licenseNum": "Số giấy phép  ",
    "phone": "Điện thoại  ",
    "email": "Email  ",
    "role": "Vai trò  ",
    "status": "Trạng thái  ",
    "affiliatedOrganization": "Nhóm  ",
    "roleTypeList1": "Người dùng chung  ",
    "roleTypeList2": "Học sinh  ",
    "roleTypeList3": "Phụ huynh  ",
    "roleTypeList101": "Quản trị viên đại lý  ",
    "roleTypeList102": "Quản trị viên  ",
    "roleTypeList301": "Super Admin  ",
    "userStatus1": "Hoạt động  ",
    "userStatus2": "Chặn  ",
    "userStatus3": "Xóa  ",
    "operate": "Hành động  ",
    "dialogName": "Biệt danh:  ",
    "dialogUserName": "ID người dùng:  ",
    "dialogUserNameDefined": "Tên người dùng:  ",
    "dialogPassword": "Mật khẩu:  ",
    "dialogID": "ID nhân viên:  ",
    "dialogRole": "Vai trò:  ",
    "dialogEmail": "Email:  ",
    "dialogPhone": "Điện thoại:  ",
    "dialogGroup": "Nhóm:  ",
    "addUser": "Người dùng mới  ",
    "editUser": "Chỉnh sửa người dùng  ",
    "addSuccess": "Thêm thành công!  ",
    "addError": "Thêm thất bại!  ",
    "editSuccess": "Chỉnh sửa thành công!  ",
    "editError": "Chỉnh sửa thất bại!  ",
    "delSuccess": "Xóa thành công!",
    "delError": "Xóa không thành công!  ",
    "cancel": "Hủy bỏ  ",
    "confirm": "Xác nhận  ",
    "save": "Lưu  ",
    "tableDel": "Xóa  ",
    "tableEdit": "Chỉnh sửa  ",
    "selectRoles": "Chọn vai trò  ",
    "delTitle": "Xóa?  ",
    "delTitleContent": "Nội dung đã chọn sẽ bị xóa khỏi cơ sở dữ liệu. Thao tác này không thể hoàn tác. Bạn có chắc chắn muốn tiếp tục?  ",
    "delCancelButton": "Hủy bỏ  ",
    "delConfirmButton": "Xác nhận  ",
    "titleRealNameRq": "Trường này phải được điền đầy đủ  ",
    "titleRealNameFormat": "Chọn tên người dùng chỉ bao gồm chữ cái và số  ",
    checkPasswordTitleTwo: 'Vui lòng đặt mật khẩu ít nhất 6 ký tự, bao gồm chữ cái và số. Có thể sử dụng ký tự đặc biệt (không giới hạn).',
    checkPasswordTitle: 'Mật khẩu phải có ít nhất 6 ký tự và không được chỉ toàn số',
    "titlePhoneFormat": "Số điện thoại chỉ có thể điền số, (), + và -  ",
    "phoneFilled": "Số điện thoại phải được điền đầy đủ  ",
    "titleEmaileFormat": "Lỗi định dạng email  ",
    "emaileFilled": "Email phải được điền đầy đủ  ",
    "titlUserNameDefinedNub": "Tên người dùng không thể vượt quá 30 ký tự  ",
    "titlRealNameNub": "Tên không thể vượt quá 30 ký tự  ",
    "titlRealNameField": "Tên phải được điền đầy đủ  ",
    "thisPasswordField": "Mật khẩu phải được điền đầy đủ  ",
    "titlPassWordNub": "Mật khẩu phải từ 6 đến 30 ký tự  ",
    "enableStatus": "Kích hoạt người dùng  ",
    "stopStatus": "Vô hiệu hóa người dùng  ",
    "enableContent": "Bạn có chắc chắn muốn kích hoạt người dùng này không?  ",
    "stopContent": "Bạn có chắc chắn muốn vô hiệu hóa người dùng này không?  ",
    "error1400": "Tên người dùng đã tồn tại, vui lòng thử lại  ",
    "error1401": "ID người dùng đã tồn tại, thao tác thất bại!  ",
    "error1402": "Nhóm không tồn tại, nhập khẩu thất bại!  ",
    "error1403": "Dữ liệu sai  ",
    "error1404": "Quyền không đủ  ",
    "selUser": "Vui lòng chọn người dùng!  ",
    "error1405": "Không thể lấy vai trò  ",
    "error1406": "Dữ liệu người dùng nhập khẩu sai định dạng  ",
    "error1407": "Email đã tồn tại và thao tác không thành công  ",
    "error1408": "Số điện thoại đã tồn tại và thao tác không thành công  ",
    "error1900": "Tham số được truy cập rỗng  ",
    "error1610": "Vui lòng sử dụng vai trò quản trị viên thiết bị đầu cuối để thực hiện các thao tác liên quan  ",
    "errorOrgIdList": "Nhóm không thể để trống!  ",
    "Bindsucceeded": "Liên kết thành công  ",
    "Bindfailed": "Liên kết thất bại  ",
    "tableuserName": "Tên người dùng  ",
    "titleDevice": "Thiết bị  ",
    "bindDevice": "Thiết bị liên kết  ",
    "Bindcontrollable": "Liên kết thiết bị có thể điều khiển ngay bây giờ?  "
  },
  "devicesMge": {
    mustChooseOne: 'Khi chọn điều khiển từ xa thông minh, phải chọn ít nhất một lệnh điều khiển',
    customName: 'Tên tùy chỉnh',
    "testAcCode": "Kiểm tra mã điều khiển A/C mới",
    "Online": "Trực tuyến",
    "Offline": "Ngoại tuyến",
    "unBindConfirm": "Xác nhận hủy kết nối Serial",
    "unBindConfirm485": "Xác nhận hủy kết nối RS485",
    "notYetBoundRS232": "Thiết bị chưa được liên kết với mã Serial. Bạn có thể vào Thiết bị > Mã điều khiển Serial để thêm nó.",
    "RsFollowingFunctions": "Có thể thực hiện các chức năng sau qua mã Serial:",
    "Unbind": "Hủy kết nối",
    "Limit255": "Tên tệp chứa tối đa 255 ký tự",
    "clear": "Xóa",
    "equipName": "Tên thiết bị",
    "equipType": "Loại",
    "selectField": "Vui lòng chọn tệp",
    "dialogTip": "*Nếu ô nhập liệu bên phải trống, nội dung bên trái sẽ được hiển thị mặc định",
    "dialogTipSingle": "*Nếu một thiết bị đơn lẻ không được đặt tên, sử dụng tên \"TẤT CẢ\"",
    "cantDelTemplateOne": "The CBX of ",
    cantDelTemplateTwo: 'CBX của thiết bị "{deviceName}" là mẫu. Bạn có chắc chắn muốn xóa không?',
    "templateTitle": "Thay thế mẫu",
    "templateContentOne": "The device name \"",
    "templateContentTwo": "\" has been set as the common CBX template. Are you sure to set the current device as the template?",
    "vcbNoTemplateNoSave": "Không thể lưu nếu không có mẫu",
    "vcbAcControl": "Chọn thiết bị A/C",
    "vcbRemoteControl": "Chọn thiết bị điều khiển từ xa",
    "vcbPOWERControl": "Điều khiển nguồn",
    "vcbRS232Control": "Điều khiển Serial",
    "vcbIRControl": "Điều khiển IR",
    "vcbSetting": "Cài đặt CBX",
    "editVcb": "Chỉnh sửa CBX",
    "vcbName": "Tên CBX",
    "iot": "Điều khiển CBX",
    "saveAsTemplate": "Lưu dưới dạng mẫu",
    saveAsTemplatereplenish: 'Chọn nhiều thiết bị để sử dụng mẫu này trong Trung tâm điều khiển',
    "Upload": "Tải lên",
    "Select": "Chọn",
    "InputDeviceID": "Nhập ID thiết bị",
    "editNameTips": "* Nội dung bên trái được hiển thị mặc định khi ô nhập liệu bên phải trống.",
    "_RS232A": "Giao diện một",
    "_RS232B": "Giao diện hai",
    "institutionDirectory": "Danh bạ tổ chức",
    "projectionScreenLinkageSetting": "Cài đặt điều khiển màn hình chiếu",
    "screenLiftingLinkageDisplaySwitch": "Điều khiển liên kết giữa màn hình chiếu và hiển thị:",
    "stopLinkage": "Tắt (Điều khiển màn hình chiếu riêng biệt)",
    "Enable": "Bật (Điều khiển đồng bộ màn hình chiếu và hiển thị)",
    "btnAddDevice": "Thêm thiết bị",
    "btnImportDevice": "Nhập thiết bị hàng loạt",
    "btnDel": "Xóa",
    "btnEdit": "Chỉnh sửa",
    "tableIpAddress": "Địa chỉ IP",
    "MACAddress": "Địa chỉ MAC",
    "firmwareVersion": "Phiên bản firmware",
    "NA": "Không có sẵn",
    "tableDeviceName": "Tên thiết bị",
    "tableStatus": "Trạng thái",
    "tableVideoSwitch": "Công tắc video",
    "tableAudio": "Phân phối A/V",
    "tablePowerControl": "Điều khiển nguồn",
    "tableRS232": "Điều khiển nối tiếp",
    "tableIR": "Điều khiển IR",
    "tableRFIDCard": "Thẻ IC",
    "tableControlPanel": "Bảng điều khiển",
    "tableOrganization": "Nhóm",
    "tableActions": "Hành động",
    "dialogAddTitle": "Thêm thiết bị",
    "dialogEditTitle": "Chỉnh sửa thiết bị",
    "dialogBatchAddTitle": "Thêm thiết bị hàng loạt",
    "dialogBatchEditTitle": "Chỉnh sửa thiết bị hàng loạt",
    "btnCancel": "Hủy",
    "Devices": "Thiết bị:",
    "ProjectorCode": "Mã Serial:",
    "Group": "Nhóm:",
    "btnBatchAdd": "Thêm hàng loạt",
    "delTitle": "Xóa?",
    "delTitleContent": "Các thành phần đã chọn sẽ bị xóa khỏi cơ sở dữ liệu. Quá trình này không thể hoàn tác. Bạn có chắc chắn muốn tiếp tục?",
    "delCancelButton": "Hủy",
    "delConfirmButton": "Xác nhận",
    "addError": "Thêm thất bại!",
    "editSuccess": "Chỉnh sửa thành công!",
    "editError": "Chỉnh sửa thất bại!",
    "delSuccess": "Xóa thành công!",
    "delError": "Xóa thất bại!",
    "content": "Tìm kiếm",
    "cancel": "Hủy",
    "confirm": "Xác nhận",
    "save": "Lưu",
    "tableDel": "Xóa",
    "tableEdit": "Chỉnh sửa",
    "selectRoles": "Chọn vai trò",
    "selectType": "Vui lòng chọn loại",
    "selectDevices": "Vui lòng chọn thiết bị",
    "titleRealNameRq": "Trường này phải được điền",
    "titleRealNameNub": "Ít hơn 100 ký tự",
    "titlPassWordNub": "Ít hơn 15 ký tự",
    "error1900": "Tham số đã truy cập trống",
    "error2000": "Vượt quá số lượng thiết bị kết nối tối đa",
    "error2001": "Mã thiết bị nhập vào không chính xác hoặc chưa được nhập vào hệ thống",
    "error2002": "Tên thiết bị nhập vào bị trùng",
    "error2003": "Mã thiết bị nhập vào đã được sử dụng",
    "error2004": "Lỗi dữ liệu nhập vào",
    "error2005": "Tên thương hiệu hoặc mẫu mã trùng với dữ liệu đã có trong hệ thống; vui lòng đặt lại tên thương hiệu hoặc mẫu mã.",
    "error2008": "Thiết bị này đã được liên kết với nhóm khác",
    "notDevicesName": "Tên thiết bị không thể để trống",
    "notDevicesNO": "Mã thiết bị không thể để trống",
    "dialogDevicesName": "Tên thiết bị:",
    "dialogDevicesID": "ID thiết bị:",
    "dialogProjectorCode": "Mã Serial:",
    "dialogGroup": "Nhóm:",
    "dialogSel": "Vui lòng chọn",
    "errorOrgIdList": "Nhóm không được để trống!",
    "errorDevicesName": "Tên thiết bị không được để trống!",
    "errorDevicesNo": "ID thiết bị không được để trống!",
    "dialogTiltleDevices": "Thiết bị:",
    "uploadSuccess": "Tải lên thành công",
    "addSuccess": "Thêm thành công",
    "ChooseGroups": "Chọn nhóm",
    "ChooseIcon": "Chọn biểu tượng",
    "dialogDevicesTitle": "Cài đặt tham số được áp dụng cho các thiết bị sau",
    "backDevice": "Quay lại",
    "bootSetting": "Tùy chọn khởi động",
    "nmpOpenSetting": "Cài đặt bật nguồn",
    "npsOpenSetting": "Cài đặt bật nguồn",
    "nmpPowerSettings": "Cài đặt năng lượng",
    "npsPowerSettings": "Cài đặt năng lượng",
    "nmpInterfaceSettings": "Cài đặt giao diện",
    "npsInterfaceSettings": "Cài đặt giao diện",
    "nmpDefaultChannel": "Cài đặt kênh mặc định",
    "nmpCloseSetting": "Cài đặt tắt",
    "npsCloseSetting": "Cài đặt tắt",
    "SwipeToStart": "Bật khóa (chạm thẻ để mở khóa)",
    "ControlPanelToStart": "Tắt khóa (hoạt động không giới hạn)",
    "Display": "Hiển thị",
    "External": "Ngoài",
    "startingUpMethod": "Bật/Tắt khóa bảng điều khiển:",
    "startWith": "Khởi động với:",
    "nmpstartWith": "Bật đồng bộ:",
    "nmpcloseWith": "Tắt đồng bộ:",
    "RS232Tip": "Khi nguồn chính tắt, tổng cộng 5 giao diện Serial, bao gồm Serial và tối đa 4 CBX, sẽ nhận mã lệnh tắt tương ứng.",
    startPowerTip: 'Khi bật nguồn, tất cả thiết bị kết nối với cổng nguồn của CBX sẽ được bật đồng thời.',
    startAirTip: 'Khi bật nguồn, tất cả điều hòa được liên kết sẽ được bật đồng bộ qua hồng ngoại của thiết bị/CBX.',
    startIrTip: 'Khi bật nguồn, gửi lệnh liên kết qua hồng ngoại của thiết bị/CBX (ví dụ: màn hình hạ xuống, máy chiếu bật).',
    startRSTip: 'Khi bật nguồn, gửi lệnh bật nguồn qua cổng Serial của thiết bị/CBX.',
    CloseDisplayTip: 'Thiết bị kết nối với cổng DISPLAY sẽ tự động tắt khi NDP/NMP tắt. Cài đặt này được quản lý bởi firmware và không thể thay đổi qua phần mềm.',
    CloseExternalTip: 'Thiết bị kết nối với cổng EXTERNAL sẽ tự động tắt khi NDP/NMP tắt. Cài đặt này được quản lý bởi firmware và không thể thay đổi qua phần mềm.',
    ClosePowerTip: 'Khi tắt nguồn, tất cả thiết bị kết nối với cổng nguồn của CBX sẽ được tắt đồng thời.',
    CloseAirTip: 'Khi tắt nguồn, tất cả điều hòa được liên kết sẽ được tắt đồng bộ qua hồng ngoại của thiết bị/CBX.',
    CloseIrTip: 'Khi tắt nguồn, gửi lệnh liên kết qua hồng ngoại của thiết bị/CBX (ví dụ: màn hình nâng lên, máy chiếu tắt).',
    CloseRSTip: 'Khi tắt nguồn, gửi lệnh tắt nguồn qua cổng Serial của thiết bị/CBX.',
    npsOpenRS232Tip: 'Khi nguồn điện chính bật, 2 cổng giao tiếp nối tiếp của NPS sẽ nhận được mã lệnh khởi động tương ứng.',
    "npsRS232Tip": "Khi nguồn chính tắt, hai giao diện Serial trên NPS sẽ nhận mã lệnh tắt tương ứng.",
    "useCardTip": "Sau khi mở khóa thẻ, nguồn điện của thiết bị sẽ tự động được kích hoạt.",
    "npsCardTip": "Sau khi mở khóa thẻ, nguồn điện chính của thiết bị sẽ tự động được kích hoạt.",
    "PowerOutageHandling": "Xử lý mất điện",
    "PowerOutageHandTip": "Để tiếp tục truy cập khi mất điện bất ngờ, chọn 'Mở khóa khi mất điện'. Nếu không, chọn 'Khóa khi mất điện' để hạn chế quyền truy cập.",
    "acSetting": "Cài đặt A/C",
    "ChooseType": "Loại thiết bị",
    "ChooseBrand": "Chọn thương hiệu",
    "ChooseModel": "Chọn mô hình",
    "btnConnectingTest": "Kiểm tra kết nối",
    "LockSetting": "Cài đặt khóa điện",
    "ElectricLockType": "Loại khóa điện:",
    "PowerUNLOCK": "Mở khóa khi mất điện",
    "PowerLOCK": "Khóa khi mất điện",
    "none": "Không có",
    "oddParity": "Kiểm tra lẻ",
    "EvenParity": "Kiểm tra chẵn",
    "LastSetting": "Cài đặt cuối cùng",
    "ElectricLockClosing": "Đóng khóa điện:",
    "manualSwitch": "Công tắc thủ công",
    "Auto": "Tự động (trong",
    "projectorSetting": "Chọn và liên kết thiết bị",
    "baudRate": "Tốc độ Baud",
    "Parity": "Kiểm tra lẻ",
    "ON": "Bật",
    "OFF": "Tắt",
    "Channel1": "Kênh 1",
    "Channel2": "Kênh 2",
    "PowerOffDelay": "Độ trễ tắt",
    "second": "s",
    "DefaultChannel": "Kênh mặc định",
    "HDMIA": "HDMI ra A:",
    "HDMIB": "HDMI ra B:",
    "HDMIC": "HDMI ra C:",
    "btnSaveApply": "Lưu và áp dụng cho...",
    "btnSave": "Lưu",
    "btnCustomize": "Tùy chỉnh",
    "ACIsPowerTitle": "Kiểm tra xem điều hòa đã bật chưa?",
    "ACIsPowerContent": "Vui lòng tắt điều hòa trước khi thử nghiệm. Nếu không bật được, hãy chắc chắn rằng thương hiệu và model điều hòa là chính xác.",
    "btnNextModel": "Không, thử mô hình tiếp theo",
    "btnYes": "Có",
    "errorConnecting": "Kiểm tra kết nối thất bại",
    "hot": "NÓNG",
    "_MAGNETICLOCK": "Khóa điện tử",
    "_AIR": "Điều hòa",
    "_POWERA": "Display Power",
    "_POWERB": "External Power",
    "_HDMI1": "HDMI in 1",
    "_HDMI2": "HDMI in 2",
    "_HDMI3": "HDMI in 3",
    "_HDMIA": "HDMI out A",
    "_HDMIB": "HDMI out B",
    "_HDMIC": "HDMI out C",
    '_AUDIOA': 'HDMI out A',
    '_AUDIOB': 'Audio IN 1',
    '_AUDIOC': 'Audio IN 2',
    "_USB1": "USB 1",
    "_USB2": "USB 2",
    "_USB3": "USB 3",
    "_USBA": "USB A",
    "_USBB": "USB B",
    "IRControl": "Cài đặt điều khiển IR",
    "acControlTitle": "Chọn thiết bị A/C:",
    "acControlTitleNew": "Thiết bị A/C",
    "intelligentControlTitle": "Chọn thiết bị điều khiển từ xa:",
    "intelligentControlTitleNew": "Thiết bị điều khiển từ xa",
    "btnACControlCode": "Xác định mã điều khiển A/C mới",
    "btnAddRemoteControl": "Mã điều khiển từ xa mới",
    "ACControlCodeTitle": "Xác định mã điều khiển A/C",
    "ACControlCodeseft1": "Xác định mã",
    "ACControlCodeseft2": "Thêm thông tin",
    "btnStartIdentify": "Bắt đầu",
    "Identifysuccess": "Nhận dạng thành công!",
    "BeingIdentify": "Đang phân tích...",
    "acBrand": "Hãng A/C",
    "acModel": "Mẫu A/C",
    "IdentifyFailureTitle": "Không tìm thấy mã",
    "IdentifyFailureContent": "Nhận dạng thất bại, mẫu này hiện không được hỗ trợ. Vui lòng thử điều khiển từ xa",
    "btnTryAgain": "Thử lại",
    "btnJump": "Đi tới điều khiển từ xa",
    "ACrideo": "A/C",
    "ortherRideo": "Thiết bị khác",
    "btnBack": "Quay lại",
    "btnSortOut": "Đi tới chỉnh sửa",
    "remoteControlSeft1": "Chọn loại thiết bị",
    "remoteControlSeft2": "Học mã",
    "remoteControlSeft3": "Thêm thông tin",
    "addRemoteControlError": "Xin lỗi, không thể học thêm mã. Vui lòng chỉnh sửa các mã điều khiển từ xa hiện tại trước",
    "btnPrevious": "Trước",
    "btnNextStep": "Tiếp theo",
    "remoteControlErrorTitle": "Học mã thất bại",
    "remoteControlErrorContent1": "1. Bộ phát hồng ngoại không bị chặn",
    "remoteControlErrorContent2": "2. Không có ánh sáng mạnh xung quanh bộ nhận",
    "remoteControlErrorContent3": "3. Bộ phát hồng ngoại được lắp đặt đúng",
    "remoteControlErrorContent4": "4. Điều khiển từ xa hoạt động tốt",
    "deviceItem1": "A/C",
    "deviceItem2": "Máy chiếu",
    "deviceItem3": "TV",
    "deviceItem4": "Quạt",
    "deviceItem5": "Đèn",
    "deviceItem6": "Khác",
    "deviceItem7": "Màn hình cảm ứng tương tác",
    "deviceItem8": "Hệ thống ghi lại bài giảng",
    "deviceItem9": "Camera PTZ",
    "RS232protocol": "Giao thức Serial:",
    "btnRemoteControl": "Bắt đầu học",
    "BeingIdentify1": "Đang phân tích...",
    "Identifysuccess1": "Thành công",
    "controllerType1": "A/C",
    "controllerType2": "Serial",
    "controllerType3": "TV",
    "controllerType4": "Quạt",
    "controllerType5": "Ánh sáng",
    "controllerType9": "Khác",
    "rqRemoteControlCode": "Vui lòng nhập tên mã điều khiển từ xa",
    "rqBrand": "Vui lòng nhập thương hiệu của A/C",
    "rqModel": "Vui lòng nhập mẫu của A/C",
    "error2016": "Tên điều khiển từ xa bị trùng, vui lòng nhập tên khác",
    "RS232Setting": "Cài đặt mã serial",
    "IR232Setting": "Cài đặt IR",
    "SystemError": "Lỗi hệ thống. Vui lòng thử lại",
    "conditionerCodeContent": "Không tìm thấy mã điều hòa, vui lòng thử lại",
    "remoteControlCodeContent": "Không tìm thấy mã điều khiển từ xa, vui lòng thử lại",
    "btnRetry": "Thử lại",
    "Bindusers": "Liên kết người dùng",
    "tablebinduser": "Liên kết người dùng",
    "Refresh": "Cập nhật",
    "Binduserlable": "Liên kết người dùng có thể điều khiển thiết bị bây giờ?",
    "SaveApplySuccessfully": "Lưu và áp dụng thành công",
    "DeviceType": "Loại:",
    "tableDeviceType": "Loại",
    "empty": "Rỗng.",
    "sendCommand": "Gửi sau",
    "enable": "Kích hoạt",
    "disable": "Vô hiệu hóa",
    "SYNCremoteControl": "Đồng bộ với điều khiển từ xa",
    "analysisfailed": "Phân tích thất bại, vui lòng thử lại",

    "CBX": {
      "powerSupplyON": "Bật nguồn",
      "powerSupplyOFF": "Tắt nguồn",
      "powerVcrON": "Bắt đầu ghi âm",
      "powerVcrOFF": "Dừng ghi âm",
      "lockScreenON": "Khóa mở",
      "lockScreenOFF": "Khóa tắt",
      "childLockON": "Bật khóa trẻ em",
      "childLockOFF": "Tắt khóa trẻ em",
      "energySavingON": "Bật tiết kiệm năng lượng",
      "energySaving": "Tiết kiệm năng lượng",
      "energySavingOFF": "Tắt tiết kiệm năng lượng",
      "signalSourceSwitchingON": "OPS",
      "signalSourceSwitchingOFF": "Android",
      "volumeAdjustment": "Loa",
      "brightAdjustment": "Độ sáng",
      "other": "Các tính năng khác...",
      "volumeExample": "Chức năng điều khiển Serial đầy đủ yêu cầu để tương thích hoàn toàn với hệ thống ghi âm",
      "functionCode": "Chức năng:",
      "Name": "Tên:",
      "controlCode": "Mã điều khiển:",
      "brand": "Thương hiệu:",
      "model": "Mẫu:",
      "errorBrandName": "Thương hiệu không thể để trống!",
      "errorModelName": "Mẫu không thể để trống!"
    }

  },
  "roleMge": {
    "role1": "Người dùng chung",
    "role101": "Quản trị viên đại lý",
    "role102": "Quản trị viên",
    "role4": "Vai trò tùy chỉnh",
    "roleNew": "Vai trò mới",
    "btnAddRole": "Thêm vai trò",
    "chooseUser": "Chọn người dùng",
    "titleLevel": "Cấp độ thuộc tính phát sóng:",
    "titleSettings": "Cài đặt quyền:",
    "btnSave": "Lưu",
    "btnDelete": "Xóa",
    "cancel": "Hủy",
    "confirm": "Xác nhận",
    "save": "Lưu",
    "addSuccess": "Thêm thành công!",
    "addError": "Thêm thất bại!",
    "editSuccess": "Chỉnh sửa thành công!",
    "editError": "Chỉnh sửa thất bại!",
    "delSuccess": "Xóa thành công!",
    "delError": "Xóa thất bại!",
    "V3_0_OrganizationManage": "Quản lý nhóm",
    "V3_0_UserManage": "Quản lý người dùng",
    "V3_0_DeviceManage": "Quản lý thiết bị",
    "V3_0_CloudSpaceManage": "Quản lý không gian đám mây",
    "V3_0_OrganizationManage_View": "Xem",
    "V3_0_OrganizationManage_Edit": "Chỉnh sửa",
    "V3_0_UserManage_View": "Xem",
    "V3_0_UserManage_Edit": "Chỉnh sửa",
    "V3_0_DeviceManage_AddDevice": "Thêm thiết bị",
    "V3_0_DeviceManage_Operating": "Vận hành",
    "V3_0_DeviceManage_Delete": "Xóa",
    "V3_0_DeviceManage_Edit": "Chỉnh sửa",
    "V3_0_CloudSpaceManage_PersonalManage": "Quản lý đám mây cá nhân",
    "V3_0_CloudSpaceManage_PublicManage": "Quản lý đám mây công cộng",
    "V3_0_CloudSpaceManage_SpaceManage": "Phân bổ không gian",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Hoạt động",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Xem",
    "V3_0_CloudSpaceManage_PublicManage_View": "Xem",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Tải lên",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Tải xuống",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Xóa tệp",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Chỉnh sửa thư mục",
    "delTitle": "Xóa?",
    "delTitleContent": "Nội dung đã chọn sẽ bị xóa khỏi cơ sở dữ liệu. Thao tác này không thể hoàn tác. Bạn có chắc chắn muốn tiếp tục không?",
    "delCancelButton": "Hủy",
    "delConfirmButton": "Xác nhận",
    "btnAdd": "Thêm vai trò",
    "RoleName": "Tên vai trò:",
    "ManageRange": "Phạm vi quản lý:",
    "ChooseUser": "Chọn người dùng:",
    "PermissionSettings": "Cài đặt quyền:",
    "BroadcastingPropertyLevel": "Cấp độ thuộc tính phát sóng",
    "ChooseGroups": "Chọn nhóm",
    "ChooseTheUser": "Chọn người dùng",
    "deleleTitle": "Vai trò mới chưa được lưu. Nếu bạn rời đi, vai trò sẽ bị xóa. Bạn có chắc chắn muốn rời đi không?",
    "Error1601": "Không thể sử dụng quản trị viên",
    "Error1602": "Lỗi khi lấy vai trò quyền hạn",
    "Error1603": "Chỉ quản trị viên mới có thể truy cập các tính năng này",
    "Error1604": "Tên vai trò không được để trống",
    "Error1605": "Nhóm không được để trống",
    "Error1606": "Vai trò này đã tồn tại",
    "Error1607": "Vai trò được xác định bởi hệ thống, không thể chỉnh sửa",
    "Error1608": "Lỗi khi thiết lập vai trò",
    "Error1609": "Vai trò người dùng chung của hệ thống, không thể chỉnh sửa",
    "Error1610": "Vui lòng sử dụng vai trò quản trị viên của đầu cuối để thực hiện các thao tác liên quan",
    "Error1611": "Không có quyền liên quan đến vai trò"
  },
  "projectorDevicesMge": {
    "tipOne": "1. Điền tên chức năng và mã điều khiển. Ví dụ mã điều khiển sử dụng định dạng HEX.",
    "tipTwo": "2. Giao diện này chỉ để cấu hình lệnh nối tiếp bật/tắt. Vui lòng đi đến 'Quản lý thiết bị / Thiết bị / Hoạt động / Cài đặt nguồn' để bật chức năng.",
    "tipFunctionOne": "1. Chọn chức năng thường dùng từ danh sách thả xuống. Các biểu tượng tương ứng sẽ hiển thị trên giao diện điều khiển nối tiếp của bảng thông minh.",
    "tipFunctionTwo": "2. Lệnh 'POWER ON' và 'POWER OFF' được sử dụng cho liên kết nối tiếp bật/tắt thiết bị. Trang này chỉ cấu hình mã điều khiển. Vui lòng đi đến 'Quản lý thiết bị / Thiết bị / Hoạt động / Cài đặt nguồn' để bật chức năng liên kết.",
    "ListRS232functions": "Danh sách chức năng điều khiển nối tiếp",
    "Customizefunctionlist": "Tùy chỉnh danh sách chức năng",
    "btnAddProjectorCode": "Thêm mã nối tiếp",
    "btnDel": "Xóa",
    "inputSeach": "Tìm kiếm",
    "btnEdit": "Chỉnh sửa",
    "cancel": "Xóa sạch",
    "confirm": "Xác nhận",
    "tableName": "Tên mã",
    "tablersType": "Loại thiết bị:",
    "tablersTypeTable": "Loại thiết bị",
    "tableModel": "Mẫu",
    "tableBrand": "Hãng",
    "tableActions": "Hành động",
    "dialogAddTitle": "Thêm mã Serial",
    "dialogEditTitle": "Chỉnh sửa mã Serial",
    "brand": "Tên hãng:",
    "model": "Mẫu:",
    "baudRate": "Tốc độ baud:",
    "parity": "Kiểm tra chẵn lẻ:",
    "powerOn": "BẬT",
    "powerOff": "TẮT",
    "pgrInput1": "Kênh 1",
    "pgbInput2": "Kênh 2",
    "delTitle": "Xóa?",
    "delTitleContent": "Nội dung đã chọn sẽ bị xóa khỏi cơ sở dữ liệu. Thao tác này không thể hoàn tác. Bạn có chắc chắn muốn tiếp tục không?",
    "delCancelButton": "Hủy",
    "delConfirmButton": "Xác nhận",
    "content": "Tìm kiếm",
    "operate": "Hành động",
    "tableDel": "Xóa",
    "tableEdit": "Chỉnh sửa",
    "addSuccess": "Thêm thành công!",
    "addError": "Thêm thất bại!",
    "editSuccess": "Chỉnh sửa thành công!",
    "editError": "Chỉnh sửa thất bại!",
    "delSuccess": "Xóa thành công!",
    "delError": "Xóa thất bại!",
    "selectTitle": "Vui lòng chọn Serial!",
    "selectCode": "Chọn Serial",
    "none": "Không có",
    "oddParity": "Kiểm tra chẵn lẻ lẻ",
    "EvenParity": "Kiểm tra chẵn lẻ chẵn"
  },
  "authorityMge": {
    "V3_0_OrganizationManage": "Quản lý nhóm",
    "V3_0_UserManage": "Quản lý người dùng",
    "V3_0_DeviceManage": "Quản lý thiết bị",
    "V3_0_CloudSpaceManage": "Quản lý không gian đám mây",
    "V3_0_OrganizationManage_View": "Xem",
    "V3_0_OrganizationManage_Edit": "Chỉnh sửa",
    "V3_0_UserManage_View": "Xem",
    "V3_0_UserManage_Edit": "Chỉnh sửa",
    "V3_0_DeviceManage_AddDevice": "Thêm thiết bị",
    "V3_0_DeviceManage_Operating": "Hoạt động",
    "V3_0_DeviceManage_Delete": "Xóa",
    "V3_0_DeviceManage_Edit": "Chỉnh sửa",
    "V3_0_DeviceManage_RepairLog": "Nhật ký sửa chữa",
    "V3_0_CloudSpaceManage_PersonalManage": "Quản lý đám mây cá nhân",
    "V3_0_CloudSpaceManage_PublicManage": "Quản lý đám mây công cộng",
    "V3_0_CloudSpaceManage_SpaceManage": "Quản lý không gian đám mây",
    "V3_0_CloudSpaceManage_PersonalManage_Operating": "Hoạt động",
    "V3_0_CloudSpaceManage_PersonalManage_View": "Xem",
    "V3_0_CloudSpaceManage_PublicManage_View": "Xem",
    "V3_0_CloudSpaceManage_PublicManage_Upload": "Tải lên",
    "V3_0_CloudSpaceManage_PublicManage_Download": "Tải xuống",
    "V3_0_CloudSpaceManage_PublicManage_DeleteFile": "Xóa",
    "V3_0_CloudSpaceManage_PublicManage_EditFolder": "Chỉnh sửa",
    "delTitle": "Xóa?",
    "delTitleContent": "Các thành phần đã chọn sẽ bị xóa khỏi cơ sở dữ liệu. Quá trình này không thể hoàn tác. Bạn có chắc chắn muốn tiếp tục không?",
    "delCancelButton": "Hủy",
    "delConfirmButton": "Xác nhận",
    "content": "Tìm kiếm",
    "operate": "Hành động",
    "tableDel": "Xóa",
    "tableEdit": "Chỉnh sửa",
    "addSuccess": "Thêm thành công!",
    "addError": "Thêm thất bại!",
    "editSuccess": "Chỉnh sửa thành công!",
    "editError": "Chỉnh sửa thất bại!",
    "delSuccess": "Xóa thành công!",
    "delError": "Xóa thất bại!",
    "selectTitle": "Vui lòng chọn Serial!"
  },
  "workstationMge": {
    "priorChoice": "Tùy chọn phát sóng:",
    "SpeedPriority": "Ưu tiên tốc độ",
    "SyncPriority": "Ưu tiên đồng bộ khung hình",
    "SpeedPriorityTip": "Sau khi gửi lệnh phát sóng AV, các thiết bị Q-NEX có thể thực hiện tác vụ phát lại trong thời gian bộ đệm ngắn khoảng 3-5 giây. Ưu tiên tốc độ được khuyến nghị khi máy chủ phương tiện hoạt động trong LAN.",
    "SyncPriorityTip": "Sau khi gửi lệnh phát sóng AV, các thiết bị Q-NEX có thể thực hiện tác vụ phát lại đồng bộ với thời gian bộ đệm khoảng 8-12 giây.",
    "btnAddMedia": "Thêm máy chủ phương tiện",
    "btnBack": "Quay lại",
    "tableMediaLibId": "ID máy chủ phương tiện",
    "tableMediaLibName": "Tên máy chủ phương tiện",
    "tableState": "Trạng thái mạng",
    "tableBindingUsers": "Người dùng đã liên kết",
    "tableLiveAddress": "Địa chỉ phát sóng",
    "tableAddress": "Địa chỉ phát trực tuyến",
    "tableOperate": "Hành động",
    "tableDel": "Xóa",
    "tableEdit": "Chỉnh sửa",
    "titleMediaStation": "Địa chỉ phát sóng",
    "titleLiveStation": "Địa chỉ phát trực tuyến:",
    "radioPublic": "Công cộng",
    "radioPrivate": "Riêng tư",
    "btnSave": "Lưu",
    "titleUsers": "Người dùng",
    "titleCanBe": "Có thể liên kết",
    "titleHaveBeen": "Đã liên kết",
    "titleMore": "Cần thêm nhiều hơn không?",
    "btnAdd": "Thêm",
    "content": "Tìm kiếm",
    "tableName": "Tên",
    "tableUserName": "Tên người dùng",
    "operate": "Hành động",
    "affiliatedOrganization": "Nhóm",
    "dialogTitle": "Thêm máy chủ phương tiện mới",
    "dialogTitleEdit": "Chỉnh sửa máy chủ phương tiện mới",
    "dialogItemName": "Tên:",
    "dialogItemId": "ID:",
    "dialogItemIp": "Địa chỉ phát sóng:",
    "titleSelectUsers": "Chọn người dùng",
    "selectMedia": "Vui lòng chọn phương tiện",
    "delTitle": "Bạn có chắc chắn muốn xóa không?",
    "delMediaLibTitle": "Xác nhận xóa?",
    "delTitleContent": "Các nội dung đã chọn sẽ bị xóa khỏi cơ sở dữ liệu. Hành động này không thể hoàn tác. Bạn có chắc chắn muốn tiếp tục không?",
    "delTitleMediaLibContent": "Hành động xóa sẽ khiến dữ liệu liên quan bị xóa và không thể khôi phục.",
    "delCancelButton": "Hủy",
    "delConfirmButton": "Xác nhận",
    "selectDevices": "Vui lòng chọn thiết bị",
    "selectUser": "Vui lòng chọn người dùng",
    "addUser": "Thêm người dùng",
    "editUser": "Chỉnh sửa người dùng",
    "addSuccess": "Thêm thành công!",
    "addError": "Thêm không thành công!",
    "editSuccess": "Chỉnh sửa thành công!",
    "editError": "Chỉnh sửa không thành công!",
    "delSuccess": "Xóa thành công!",
    "delError": "Xóa không thành công!",
    "cancel": "Hủy",
    "confirm": "Xác nhận",
    "save": "Lưu",
    "error2500": "Vượt quá số lượng thiết bị tối đa có thể kết nối với trạm làm việc hiện tại.",
    "DeviceName": "Tên thiết bị",
    "AssociatedUserManagement": "Quản lý người dùng liên kết",
    "btnDel": "Xóa",
    "errorMsgId": "Không thể tìm thấy ID này",
    "LiveStreaming": "Địa chỉ phát trực tuyến:",
    "NoFoundMediaId": "Không thể lấy ID của máy chủ phương tiện",
    "AlreadyConnectedOrg": "Máy chủ đa phương tiện đã được liên kết với tổ chức khác",
    "AlreadyBoundMedia": "Tổ chức này đã liên kết một máy chủ đa phương tiện và không thể liên kết thêm",
    "DeleteSecondaryConfirmation": "Dữ liệu không thể khôi phục sau khi xóa máy chủ đa phương tiện, vui lòng xác nhận lại."
  },
  "cloudDiskMge": {
    "totalStorage": "LƯU TRỮ TỔNG CỘNG",
    "GetMore": "Nhận thêm",
    "StorageSpace": "Không gian lưu trữ",
    "Adjustment": "Điều chỉnh",
    "moreSpace": "Nhận thêm không gian lưu trữ",
    "PublicStorage": "Lưu trữ công cộng",
    "PublicStorageUsed": "Lưu trữ công cộng đã sử dụng",
    "PublicStorageLasted": "Lưu trữ công cộng còn lại",
    "IndividualStorageUsed": "Lưu trữ cá nhân đã sử dụng",
    "IndividualStorageLasted": "Lưu trữ cá nhân còn lại",
    "storageSpace": "Điều chỉnh không gian lưu trữ",
    "tableUserName": "Tên người dùng",
    "tableUsedSpace": "Không gian đã sử dụng",
    "tableAvailableSpace": "Không gian có sẵn",
    "tableActiveTime": "Thời gian hoạt động cuối",
    "tableOperate": "Hành động",
    "cleanup": "Ghi chú dọn dẹp",
    "IndividualStorageSpaceAdjustment": "Điều chỉnh không gian lưu trữ cá nhân",
    "titleTotal": "Tổng cộng",
    "PublicDisk": "Đám mây công cộng",
    "IndividualDisk": "Đám mây cá nhân",
    "PerUser": "Theo người dùng",
    "UsersInTotal": "Tổng số người dùng",
    "cancel": "Hủy",
    "confirm": "Xác nhận",
    "save": "Lưu",
    "addSuccess": "Thêm thành công!",
    "addError": "Thêm thất bại!",
    "editSuccess": "Chỉnh sửa thành công!",
    "editError": "Chỉnh sửa thất bại!",
    "delSuccess": "Xóa thành công!",
    "delError": "Xóa thất bại!",
    "error3000": "Hoạt động không thành công vì dung lượng lưu trữ tổng cộng đã vượt quá giới hạn.",
    "error3003": "Hoạt động thất bại, vui lòng kiểm tra xem đã cài đặt Máy chủ phương tiện chưa.",
    "IndividualStorage": "Lưu trữ cá nhân",
    "NoteToCleanup": "Ghi chú dọn dẹp",
    "updatePersonalSuccess": "Không gian lưu trữ đám mây của bạn sẽ đầy, vui lòng dọn dẹp kịp thời",
    "updatePersonalSuccess1": "Đã chỉnh sửa và lưu thành công",
    "storageUsage": "Sử dụng lưu trữ cá nhân",
    "bindIndividualstorage": "Người dùng được phép có lưu trữ đám mây cá nhân",
    "UserIndividualstorage": "Người dùng đã thiết lập lưu trữ đám mây cá nhân",
    "Notificationsuccessfully": "Thông báo đã gửi thành công",
    "Notificationfailed": "Thông báo gửi thất bại",
    "tableName": "Tên",
    "userID": "ID người dùng"
  },
  "dashboard": {
    "exportPdf": "Xuất PDF",
    "or": "-",
    "warrantyCompletionRate": "Tỷ lệ sửa chữa",
    "frequencyOfEachModule": "Tỷ lệ sửa chữa của từng mô-đun chức năng",
    "repairHandling": "Trạng thái xử lý sửa chữa",
    "sourceSwitchInput": "Công tắc đầu vào",
    "micVol": "Âm lượng micro",
    "volumeSpeaker": "Âm lượng loa",
    "airAonditioner": "Điều hòa không khí",
    "Curtain": "Màn hình máy chiếu",
    "remoteControlIntelligent": "Điều khiển từ xa",
    "RS232Control": "Điều khiển Serial",
    "lockElectronic": "Khóa điện tử",
    "Repairreportcompleted": "Đã sửa chữa",
    "Totalnumberofrepairsreported": "Tổng số lần sửa chữa",
    "Warrantycompletionrate": "Tỷ lệ hoàn thành sửa chữa",
    "startDate": "Ngày bắt đầu",
    "endDate": "Ngày kết thúc",
    "year": "Năm",
    "month": "Tháng",
    "dayTian": "Ngày",
    "placeholderDate": "Chọn ngày",
    "placeholderDateTime": "Chọn giờ",
    "devicesNub": "Thiết bị",
    "userNub": "Người dùng",
    "powerNub": "Công suất (KW/H)",
    "storageUsed": "Dung lượng sử dụng (%)",
    "userLoginDevice": "Thời gian đăng nhập người dùng hoạt động",
    "devicePowerConsumption": "Tiêu thụ điện năng hàng ngày của tất cả các thiết bị",
    "externalDeviceUsageTime": "Sử dụng thiết bị ngoại vi",
    "equipmentRunningTime": "Sử dụng thiết bị đầu cuối",
    "cloudStorageSpace": "Sử dụng lưu trữ",
    "powerConsumptionPort": "Tiêu thụ năng lượng của mỗi cổng nguồn",
    "mostPopularFile": "Tệp phổ biến nhất",
    "commonFunctions": "Chức năng thường xuyên",
    "commonlyUsed": "Phương pháp phát sóng thường dùng",
    "fileName": "Tên tệp",
    "usageCount": "Số lần sử dụng",
    "electricityConsumption": "Tiêu thụ điện năng",
    "publicStorageUsed": "Dung lượng lưu trữ công cộng đã sử dụng",
    "publicStorageLasted": "Dung lượng lưu trữ công cộng còn lại",
    "individualStorageUsed": "Dung lượng lưu trữ cá nhân đã sử dụng",
    "individualStorageLasted": "Dung lượng lưu trữ cá nhân còn lại",
    "notification": "Thông báo",
    "audioBroadcast": "Phát sóng âm thanh",
    "videoBroadcast": "Phát sóng video",
    "ac": "Điều hòa không khí",
    "hDMISwitch": "Công tắc HDMI",
    "powerControl": "Kiểm soát năng lượng",
    "powercontrol": "Kiểm soát năng lượng",
    "Lock": "Khóa",
    "volumeAdjust": "Điều chỉnh âm lượng",
    "projectionScreen": "Màn hình chiếu",
    "today": "Hôm nay",
    "yesterday": "Hôm qua",
    "thisWeek": "Tuần này",
    "lastWeek": "Tuần trước",
    "lastMonth": "Tháng trước",
    "thisMonth": "Tháng này",
    "times": "Lần",
    "usage": "Số lần sử dụng",
    "eachrTitle": "Phút",
    "total": "Tổng cộng",
    "NMPSystemissue": "Vấn đề hệ thống NMP",
    "displayPower": "Vấn đề thiết bị ngoại vi NMP",
    "externalPower": "Vấn đề hệ thống MBX",
    "screen": "Vấn đề thiết bị ngoại vi MBX",
    "TotalRepairs": "Tổng số lần sửa chữa",
    "Repaired": "Đã sửa chữa",
    "Unrepaired": "Chưa sửa chữa",
    "day": "NGÀY",
    "Minutes": "Phút",
    "powerConsumption": "Phút",
    "Date": "Ngày",
    "kw": "KW",
    "month1": "T2",
    "month2": "T3",
    "month3": "T4",
    "month4": "T5",
    "month5": "T6",
    "month6": "T7",
    "month7": "CN",
    "enmonth1": "Tháng 1",
    "enmonth2": "Tháng 2",
    "enmonth3": "Tháng 3",
    "enmonth4": "Tháng 4",
    "enmonth5": "Tháng 5",
    "enmonth6": "Tháng 6",
    "enmonth7": "Tháng 7",
    "enmonth8": "Tháng 8",
    "enmonth9": "Tháng 9",
    "enmonth10": "Tháng 10",
    "enmonth11": "Tháng 11",
    "enmonth12": "Tháng 12",
    "noData": "Không có dữ liệu"
  },
  "input": {
    "fivedigits": "Vui lòng nhập số nguyên dương trong 5 chữ số",
    "titlUserNameField": "Tên người dùng này phải được điền",
    "thisField": "Trường này phải được điền",
    "ChooseGroup": "Chọn nhóm",
    "placeholder": "Chọn",
    "placeholder_type": "Vui lòng chọn các loại điều khiển thiết bị",
    "titlRealNameField": "Mật khẩu phải được điền",
    "thisPasswordField": "Mật khẩu phải được điền",
    "titlPassWordNub": "Ít hơn 15 chữ cái",
    "Post": "Chỉ số",
    "passwordNoChinese": "Ô nhập này không thể điền bằng ký tự Trung Quốc"
  },
  "transfer": {
    "all": "Tất cả",
    "Choose": "Chọn",
    "Selected": "Đã chọn",
    "Subordinate": "Cấp dưới"
  },
  "setting": {
    limitPngGif: 'Chỉ hỗ trợ định dạng PNG / GIF',
    limit3M: 'Kích thước hình ảnh không được vượt quá 3MB',
    setting_door_Wallpaper_text: 'Kích thước hình ảnh đề xuất: 1280x800, định dạng PNG hoặc GIF',

    "reduction": "Khôi phục",
    "limitJpg": "Ảnh đại diện đã tải lên chỉ có thể ở định dạng PNG!",
    "limit2M": "Kích thước của ảnh đại diện đã tải lên không được vượt quá 2MB!",
    "choseFile": "Chọn tệp",
    "textOne": "1. Hình ảnh LOGO khuyến nghị: kích thước 117*40, ở định dạng PNG",
    "textTwo": "2. Sau khi tải lên, vui lòng chuyển đến Bảng điều khiển cảm ứng và đảm bảo rằng bảng điều khiển cảm ứng đã kết nối với Internet, sau đó nhấp vào logo ban đầu để làm mới.",
    "customizeLogo": "Cài đặt logo bảng điều khiển cảm ứng",
    "addSuccess": "Cài đặt thành công!",
    "settingIp": "Cài đặt địa chỉ IP lưu trữ tệp",
    "ServerIP": "Địa chỉ IP của máy chủ:",
    "ServerPort": "Cổng máy chủ:",
    "btnSave": "Lưu",
    "TimeZoneSetting": "Cài đặt múi giờ",
    "CurrentTime": "Thời gian hiện tại:",
    "CurrentTimeZone": "Múi giờ hiện tại:",
    "httpsSetting": "Lưu trữ tệp:",
    "utcName": "Giờ chuẩn Greenwich UTC/GMT",
    "utc0": "Giờ chuẩn Greenwich, Vương quốc Anh, Lisbon, Torshavn, London, Dublin, Edinburgh",
    "utc0_5": "",
    "utc1": "Châu Âu Trung tâm, Tây Phi, Tây Trung Phi, Đức, Ireland, Pháp, Amsterdam, Ý, Berlin, Rome, Tây Ban Nha, Prague, Belgrade, Brussels, Paris, Madrid, Tunisia, Gabon, Ma-rốc",
    "utc1_5": "",
    "utc2": "Châu Âu Đông, Trung Phi, Thổ Nhĩ Kỳ, Israel, Nam Phi, Istanbul, Cairo, Athens, Damascus",
    "utc2_5": "",
    "utc3": "Châu Phi Đông, Nga, Baghdad, Kuwait, Moscow, St. Petersburg",
    "utc3_5": "Iran",
    "utc4": "Abu Dhabi, Tbilisi, Dubai, Mauritius, Port Louis",
    "utc4_5": "Afghanistan",
    "utc5": "Pakistan, Turkmenistan, Maldives, Uzbekistan, Armenia, Tajikistan Ấn Độ, Mumbai, New Delhi, Bangalore, Kolkata",
    "utc5_5": "Ấn Độ, Sri Lanka",
    "utc6": "Novosibirsk, Kyrgyzstan, Bangladesh, Bhutan",
    "utc6_5": "Quần đảo Cocos Australia, Việt Nam",
    "utc7": "Thái Lan, Bangkok, Hà Nội, Jakarta",
    "utc7_5": "",
    "utc8": "Trung Quốc, Malaysia, Philippines, Singapore, Đài Loan Trung Quốc, Macao Trung Quốc, Hong Kong Trung Quốc",
    "utc8_5": "",
    "utc9": "Nhật Bản, Hàn Quốc, Tokyo, Seoul, Sapporo, Osaka, Đông Timor",
    "utc9_5": "Giờ tiêu chuẩn trung ương Australia",
    "utc10": "Australia, Vladivostok, Guam, Canberra, Melbourne, Sydney, Papua New Guinea",
    "utc10_5": "Đảo Lord Howe của New South Wales, Australia",
    "utc11": "Quần đảo Solomon, đảo Sakhalin",
    "utc11_5": "Đảo Norfolk, Australia",
    "utc12": "New Zealand, Auckland, Wellington, Fiji, New Zealand, Nauru",
    "utc12_5": "",
    "utc13": "Cape Verde, Azores",
    "utc13_5": "",
    "utc14": "Nam Georgia, Fernando de Noronha",
    "utc14_5": "",
    "utc15": "Brazil, Santiago, El Salvador, Brasilia, Uruguay, Argentina, Suriname",
    "utc15_5": "Giờ chuẩn Newfoundland",
    "utc16": "Venezuela, Bolivia, Paraguay, Chile",
    "utc16_5": "Venezuela",
    "utc17": "Giờ miền Đông (Hoa Kỳ và Canada), Colombia, Toronto, Ecuador, Peru, Cuba, New York, Hamilton, San Diego",
    "utc17_5": "",
    "utc18": "Giờ trung tâm Hoa Kỳ và Canada, Mexico City, Monterrey, Chicago, Houston, New Orleans, Memphis",
    "utc18_5": "",
    "utc19": "Giờ núi, Arizona, Mazatlán, Phoenix, Salt Lake City, Denver, Edmonton",
    "utc19_5": "",
    "utc20": "Giờ Thái Bình Dương, Los Angeles, San Francisco, Vancouver, Seattle, Las Vegas",
    "utc20_5": "",
    "utc21": "Alaska",
    "utc21_5": "Polynesia Pháp, Quần đảo Marquesas",
    "utc22": "Hawaii",
    "utc22_5": "",
    "utc23": "Samoa, Niue",
    "utc23_5": "",
    "utc24": ""
  },
  "repairLog": {
    "DeviceName": "Tên thiết bị:",
    "Time": "Thời gian:",
    "startDate": "Ngày bắt đầu",
    "endedDate": "Ngày kết thúc",
    "or": "-",
    "Problem": "Vấn đề:",
    "btnSearch": "Tìm kiếm",
    "tableNO": "Không",
    "tableDeviceName": "Tên thiết bị",
    "tableGroup": "Nhóm",
    "tableStatus": "Trạng thái",
    "tableDeliveredTime": "Thời gian giao hàng",
    "tableSubmitter": "Người gửi",
    "tableUpdatingTime": "Thời gian cập nhật",
    "tableProblem": "Vấn đề",
    "tableAdmin": "IT-Admin",
    "tableAdminReply": "Phản hồi của quản trị viên",
    "tableAttachment": "Tệp đính kèm",
    "state0": "Đã giao hàng",
    "state1": "Đang xử lý",
    "state2": "Đã hoàn thành",
    "Problem100": "TẤT CẢ",
    "Problem0": "Vấn đề hệ thống",
    "Problem1": "Vấn đề thiết bị ngoại vi",
    "ProblemType": "",
    "ProblemType0": "Điều khiển nguồn",
    "ProblemType1": "Công tắc HDMI",
    "ProblemType2": "Microphone",
    "ProblemType3": "Loa",
    "ProblemType4": "Điều hòa không khí",
    "ProblemType5": "Màn hình máy chiếu",
    "ProblemType6": "Khóa điện tử",
    "ProblemType7": "Phát sóng A/V",
    "ProblemType8": "Điều khiển IR",
    "ProblemType9": "Điều khiển Serial",
    "dialogDeviceName": "Tên thiết bị",
    "dialogDeviceID": "Mã thiết bị",
    "dialogGroup": "Nhóm",
    "dialogSubmitter": "Người gửi",
    "dialogStatus": "Chọn trạng thái",
    "dialogProblem": "Vấn đề",
    "dialogNotes": "Ghi chú",
    "dialogRepairation": "Sửa chữa",
    "dialogInProcess": "Đang xử lý",
    "dialogCompleted": "Đã hoàn thành",
    "editSuccess": "Chỉnh sửa thành công!",
    "editError": "Chỉnh sửa thất bại!",
    "problemRequired": "Vui lòng chọn loại vấn đề",
    "detailRequired": "Vui lòng mô tả vấn đề chi tiết",
    "statusRequired": "Vui lòng chọn trạng thái của nhật ký",
    "btnCancel": "Hủy",
    "DeliveredTime": "Thời gian giao hàng",
    "UpdatingTime": "Thời gian cập nhật",
    "ITAdmin": "IT-Admin",
    "AdminReply": "Phản hồi của quản trị viên",
    "Note": "Ghi chú",
    "Detail": "Chi tiết",
    "controlPanel": "Bảng điều khiển",
    "DeviceType": "Loại",
    "dialogDeliveredTime": "Thời gian giao hàng",
    "Submitter": "Người gửi"
  },
  "remoteControl": {
    "QuickActionName": "Tên",
    "DeviceType": "Loại",
    "Description": "Mô tả",
    "tableDescription": "Mô tả",
    "editRemoteControl": "Chỉnh sửa mã điều khiển từ xa",
    "QuickActionNameInput": "Tên",
    "DescriptionInput": "Mô tả",
    "save": "Lưu",
    "Brand": "Thương hiệu",
    "Model": "Mẫu mã",
    "EditACControlCode": "Chỉnh sửa mã điều khiển máy điều hòa",
    "acBrand": "Thương hiệu máy điều hòa",
    "acModel": "Mẫu mã máy điều hòa"
  },
  "card": {
    "btnAddCard": "Thêm thẻ",
    "btnBatchAddCard": "Thêm thẻ theo lô",
    "tableCard": "Số thẻ",
    "tableState": "Trạng thái",
    "tableUser": "Liên kết người dùng",
    "tableID": "Tên người dùng",
    "tableType": "Loại thẻ",
    "tableFfective": "Ngày hết hạn",
    "dialogCard": "Số thẻ :",
    "dialogState": "Trạng thái :",
    "dialogUser": "Liên kết người dùng :",
    "dialogID": "Tên người dùng :",
    "dialogType": "Loại thẻ :",
    "dialogFfective": "Ngày hết hạn :",
    "dialogRemarks": "Ghi chú :",
    "dialogAddTitle": "Thêm thẻ",
    "dialogEidtTitle": "Chỉnh sửa thẻ",
    "code2201": "Định dạng thời gian hết hạn của thẻ không đúng",
    "code2202": "Thẻ này đã được liên kết",
    "code2203": "Người dùng này đã được liên kết",
    "code2204": "Thẻ này chưa được liên kết",
    "mastCard": "Thẻ chính",
    "regularCard": "Thẻ chung",
    "permanent": "Vĩnh viễn",
    "coxPermanent": "Vĩnh viễn",
    "coxTime": "Khoảng thời gian xác định",
    "tableDeviceName": "Tên thiết bị",
    "tableDeviceID": "ID thiết bị",
    "tableOperating": "Hoạt động",
    "tableOperatingTime": "Thời gian hoạt động",
    "tableCardID": "Số thẻ",
    "tableCardType": "Loại thẻ",
    "tabluserName": "Tên người dùng",
    "tabluserId": "ID người dùng",
    "unlockPanel": "Mở bảng",
    "unlock": "Mở cửa",
    "conAll": "Tất cả",
    "btnEnable": "Kích hoạt",
    "btnDisable": "Vô hiệu hóa",
    "enableSuccess": "Kích hoạt thành công",
    "stopSuccess": "Vô hiệu hóa thành công",
    "enableError": "Không thể kích hoạt",
    "stopError": "Không thể vô hiệu hóa",
    "batchCard": "Số thẻ theo lô :",
    "titlCardField": "Số thẻ không được để trống",
    "titlCardFieldFormat": "Chỉ chữ cái và số",
    "dialogBachAddTitle": "Thêm thẻ theo lô",
    "pleaseTryAgain1": "Số thẻ sai (NO. :",
    "pleaseTryAgain2": " )，vui lòng thử lại"
  },
  privacy: {
    PrivacyPolicy: 'Microsoft Organization Binding Privacy Agreement',
    Byusing: 'Dear User,',
    whatinformation: 'Before authorizing Q-NEX to access Microsoft data, please read this agreement carefully. This document is a supplement to the Q-NEX Privacy Policy, and it specifically explains the permissions required for synchronization, the purposes of data usage, and our protection measures. By checking “Agree,” you confirm that you have read and accepted all terms of this agreement.',
    EffectiveDate: 'Effective Date: August 4, 2025',
    title1: 'Required Permissions & Collected Data',
    title1Respects1: 'To enable synchronization between Q-NEX Room Scheduler and Microsoft Calendar, Q-NEX requires the following Microsoft permissions:',
    title1Respects2: 'Delegated Permissions',
    Respects2formation: 'These permissions allow Q-NEX to access your Microsoft account data after login and consent:',
    Respects2formation2: 'Calendars.ReadWrite',
    Respects2formation3: 'Permission Name: Full access to user calendars',
    Respects2formation4: 'Description: Allows the app to create, read, update, and delete events in user calendars.',
    Respects2formation5: 'Purpose: Synchronize personal calendar meetings with the Q-NEX system.',
    Respects2formation6: 'offline_access',
    Respects2formation7: 'Permission Name: Maintain access to data you’ve granted',
    Respects2formation8: 'Description: Allows the app to access authorized data even when you’re not actively using it.',
    Respects2formation9: 'Purpose: Ensures meeting information remains synced even when users are offline.',
    Respects2formation10: 'Openid',
    Respects2formation11: 'Permission Name: Sign in as you',
    Respects2formation12: 'Description: Enables login via work/school accounts and allows the app to read basic profile details.',
    Respects2formation13: 'Purpose: Authenticates user identity for security and associates profiles with meeting data.',
    Respects2formation14: 'Place.Read.All',
    Respects2formation15: 'Permission Name: Read all company places',
    Respects2formation16: 'Description: Allows the app to read company locations (meeting rooms and room lists) on your behalf.',
    Respects2formation17: 'Purpose: Retrieves company room resource lists and syncs meeting room booking statuses.',

    tp1: 'Application Permissions (Requires Admin Consent)',
    tp2: 'These permissions enable Q-NEX to sync data automatically without manual reauthorization:',
    tp3: 'Calendars.ReadWrite',
    tp4: 'Permission Name: Read and write calendars in all mailboxes',
    tp5: 'Description: Allows the app to create, read, update, and delete calendar events without user sign-in.',
    tp6: 'Purpose: Syncs schedules from all company meeting room resource mailboxes.',
    tp7: 'Directory.Read.All',
    tp8: 'Permission Name: Read directory data',
    tp9: 'Description: Allows the app to read organizational directory data (users, groups, apps) without user sign-in.',
    tp10: 'Purpose: Validates meeting room resource mailboxes and retrieves organizational structure.',
    tp11: 'User.Read.All',
    tp12: 'Permission Name: Read all users’ full profiles',
    tp13: 'Description: Allows the app to read user profiles without user sign-in.',
    tp14: 'Purpose: Identifies meeting participants.',
    tp15: 'Place.Read.All',
    tp16: 'Permission Name: Read all company places',
    tp17: 'Description: Allows the app to read company locations (meeting rooms and room lists) for calendar events and other apps without user sign-in.',
    tp18: 'Purpose: Retrieves full meeting room resource lists and syncs availability statuses.',

    title2: 'Purpose of Data Usage',
    title2Respects1: 'Sync Microsoft Calendar meetings to Q-NEX for real-time display on the Room Scheduler.',
    title2Respects2: 'Automatically update room availability to prevent scheduling conflicts.',
    title2Respects3: 'Provide a unified meeting management experience.',

    title3: 'Data Storage & Protection',
    title3Respects1: 'All synced data is encrypted and stored on Q-NEX servers, used solely for this functionality.',
    title3Respects2: 'Q-NEX does not share calendar data with third parties unless legally required or for system security.',
    title3Respects3: 'For cross-border data transfers, we will ensure compliance with applicable laws through contractual terms or certification mechanisms.',

    title4: 'Your Rights',
    title4Respects1: 'You may unbind your Microsoft account at any time via the Q-NEX Console to stop data synchronization.',

    title5: 'Important Notes',
    title5Respects1: 'Please ensure you have administrative rights or legal authorization for the Microsoft account you bind.',
    title5Respects2: 'Once unbound, Q-NEX will stop syncing new data, but historical data may be retained for a certain period as required by compliance obligations.',

    contactInformation: 'Contact Information',
    contactInformationContent: 'If you have any questions, please contact: info@qnextech.com',

  }
}



// WEBPACK FOOTER //
// ./src/lang/vi.js